import React, { useState, useEffect } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";

// React DateTime
import Datetime from "react-datetime";
import moment from "moment";
import Select from "react-select";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import RecModal from "../../../components/Modal/RecModal";
import ApModal from "../../../components/Modal/ApModal";
import ItemModal from "../../../components/Modal/ItemModal";
import DeposModal from "../../../components/Modal/DeposModal";
import FormAction from "../../../components/Actions/FormAction";
import PoModal from "../../../components/Modal/PoModal";
import { recDetailModel } from "../../../../model/Purchase/RecDetailModel";
import WtaxModal from "../../../components/Modal/WtaxModal";

// Model
import { payMasterModel } from "../../../../model/Purchase/PayMasterModel";
import { payDetailModel } from "../../../../model/Purchase/PayDetailModel";
import FileModal from "../../../components/Modal/FileModal";

// Utils
import {
  getData,
  getDataWithComp,
  getByDocId,
  getByRecId,
  getByPayId,
  getDocType,
  getTransType,
  getViewAp,
  getViewItem,
  getAlert,
  formatCurrency,
  parseCurrency,
  getMaxPayNo,
  updateStatusByNo,
  deleteData,
  updateQty,
  randomDelay,
  getViewPoH,
  insertData,
  updateData,
} from "../../../../utils/SamuiUtils";

import {
  formatStringDateToDate,
  formatDateOnChange,
  formatDateTime,
  formatThaiDateUi,
  formatThaiDateUiToDate,
  getCreateDateTime,
  setCreateDateTime,
} from "../../../../utils/DateUtils";

function Form({ callInitialize, mode, name, maxPayNo, getReport, masterList }) {
  const [formMasterList, setFormMasterList] = useState([payMasterModel()]);
  // console.debug("formMasterList", formMasterList);
  const [formDetailList, setFormDetailList] = useState([]);
  const [tbDocType, setTbDocType] = useState([]);
  const [tbTransType, setTbTransType] = useState([]);
  const [recDataList, setRecDataList] = useState([]);
  const [apDataList, setApDataList] = useState([]);
  const [arDataList, setArDataList] = useState([]);
  const [itemDataList, setItemDataList] = useState([]);
  const [whDataList, setWhDataList] = useState([]);
  const [deposDataList, setDeposDataList] = useState([]);
  const [poDataList, setPoDataList] = useState([]);
  const [docRef, setDocRef] = useState("");
  const [Ref_PAY_ID, setRef_PAY_ID] = useState();
  const [whid, setWhid] = useState(0);

  // การคำนวณเงิน
  const [selectedDiscountValueType, setSelectedDiscountValueType] =
    useState("2");
  const [totalPrice, setTotalPrice] = useState(0);
  const [receiptDiscount, setReceiptDiscount] = useState(0);
  const [subFinal, setSubFinal] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [outstandingBalance, setOutstandingBalance] = useState(0);
  const [isVatChecked, setIsVatChecked] = useState(true);
  const [vatAmount, setVatAmount] = useState(0);

  const [FinalTotal, setFinalTotal] = useState(0);
  const [disTotal, setDisTotal] = useState(0);
  const [inputValuedisTotal, setInputValuedisTotal] = useState("0.00");
  const [totalWT, setTotalWT] = useState(0);
  const [inputValueTotalWT, setInputValueTotalWT] = useState("0.00");

  const [selectedOption, setSelectedOption] = useState(1);
  const currentDate = moment().add(543, "years").format("DD/MM/YYYY");
  const [taxData, setTaxData] = useState([
    {
      id: 1,
      type: 5,
      percent: 3.0,
      date: currentDate,
      amount: 0.0,
      tax: 0.0,
      remark: "",
    },
    {
      id: 2,
      type: 6,
      percent: 3.0,
      date: currentDate,
      amount: 0.0,
      tax: 0.0,
      remark: "",
    },
  ]);
  const [taxtotalAmount, setTaxtotalAmount] = useState(0);

  // การใช้ Tab เพื่อเปลี่ยน Form
  const [activeTab, setActiveTab] = useState("summary");

  // การแสดงสถานะใบ
  const [statusName, setStatusName] = useState("");
  const [statusColour, setStatusColour] = useState("");
  const [displayPayNo, setDisplayPayNo] = useState(maxPayNo);

  useEffect(() => {
    setDisplayPayNo(maxPayNo);
  }, [maxPayNo]);

  useEffect(() => {
    const selectedDate = formMasterList[0]?.payDate;
    if (mode === "U" || !selectedDate) return undefined;

    let isActive = true;
    const refreshPaymentDisplayNo = async () => {
      try {
        const payNoList = await getDataWithComp("PAY_H", "ORDER BY Pay_No DESC");
        const nextPayNo = getMaxPayNo(payNoList, selectedDate);
        if (isActive) setDisplayPayNo(nextPayNo);
      } catch (error) {
        console.error("Unable to refresh payment document number", error);
      }
    };

    refreshPaymentDisplayNo();
    return () => {
      isActive = false;
    };
  }, [mode, formMasterList[0]?.payDate]);

  // ใช้สำหรับการ Rendered Form ต่างๆ
  const [docRefType, setDocRefType] = useState("1");

  // ใช้สำหรับการทำเรื่องจ่ายเป็นงวด
  const [paymentStatus, setPaymentStatus] = useState("oneTime"); // สถานะการจ่าย (จ่ายครั้งเดียว หรือ จ่ายเป็นงวด)
  const [installmentCount, setInstallmentCount] = useState(1); // จำนวนงวด

  // ใช้สำหรับสะสม CreditTerm ของผู้ขายที่มาจากใบรับสินค้า
  const [creditTerm, setCreditTerm] = useState(0);

  // ใช้สำหรับเก็บสถานะที่มาจากการทำใบจ่ายเพิ่มเติม
  const [isPayContinue, setIsPayContinue] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);


  const handleRemoveImage = async (index) => {
    const fileToRemove = selectedFiles[index];

    // ถ้าตัวที่ลบเป็น URL ตามเงื่อนไขให้ลบจากฐานข้อมูล
    if (
      fileToRemove.startsWith(
        "https://encotech.s3.ap-southeast-1.amazonaws.com/"
      )
    ) {
      await deleteData(
        "Upload_File_List",
        `WHERE File_Name= '${fileToRemove}'`
      );
    }

    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));

    if (selectedFiles.length === 1) {
      setShowModal(false);
    }
  };

  function handleInputFileChange(e) {
    const files = e.target.files;
    const file = files ? files[0] : null;
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setSelectedFiles((prev) => [...prev, e.target?.result]);
      };
      reader.readAsDataURL(file);
    }
  }

  const handleShowModal = async () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*, .pdf, .doc, .docx, .xls, .xlsx";
    input.multiple = false;
    input.onchange = (e) => handleInputFileChange(e);
    input.click();
    setShowModal(true);
  };

  const [showViewModal, setShowViewModal] = useState(false);
  const handleClose = () => {
    setShowViewModal(false);
  };

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      const docTypeList = await getDocType(1);
      if (docTypeList && docTypeList.length > 0) {
        setTbDocType(docTypeList);
      }

      const poDataList = await getViewPoH();

      if (poDataList && poDataList.length > 0) {
        const filteredList = poDataList.filter(
          (item) =>
            item.DocStatus_Name === "อนุมัติ" &&
            item.Doc_Status_ReceiveName !== "รับสินค้าครบ"
        );
        setPoDataList(filteredList);
      }

      const transTypeList = await getTransType();
      if (transTypeList && transTypeList.length > 0) {
        setTbTransType(transTypeList);
      }

      // ดึงข้อมูลทั้งหมดจาก API_0301_REC_H และจัดเรียงตาม Rec_No
      const recDataList = await getDataWithComp("API_0301_REC_H", "");
      if (recDataList && recDataList.length > 0) {
        // สร้างรายการ Rec_No จาก recDataList
        const recNos = recDataList.map((record) => record.Rec_No);

        // ดึงข้อมูลจาก REC_H โดยใช้ Rec_No ที่ได้จาก API_0301_REC_H
        // และกรองตาม Rec_Status = 2 และ Doc_Status_Paid <> 2 หรือเป็น NULL
        const recHFilterQuery = `
                    AND Rec_Status = 2
                    AND (Doc_Status_Paid IS NULL OR Doc_Status_Paid <> '2')
                    AND Rec_No IN (${recNos.map((no) => `'${no}'`).join(", ")})
                `;
        const recHFiltered = await getDataWithComp("REC_H", recHFilterQuery);

        // สร้างชุด Rec_No ที่ผ่านการกรองจาก REC_H
        const filteredRecNos = new Set(
          recHFiltered.map((record) => record.Rec_No)
        );

        // กรอง recDataList ตาม Rec_No ที่ผ่านการกรอง
        const filteredRecDataList = recDataList.filter((record) =>
          filteredRecNos.has(record.Rec_No)
        );

        // จัดเรียงข้อมูลตาม Rec_No ในลำดับ DESC
        filteredRecDataList.sort((a, b) => b.Rec_No.localeCompare(a.Rec_No));

        // ตั้งค่าผลลัพธ์ที่กรองและจัดเรียงแล้ว
        setRecDataList(filteredRecDataList);
      }

      const apDataList = await getViewAp();
      if (apDataList && apDataList.length > 0) {
        setApDataList(apDataList);
      }

      const arDataList = await getDataWithComp(
        "Tb_Set_AR",
        "ORDER BY AR_Code ASC"
      );
      if (arDataList && arDataList.length > 0) {
        setArDataList(arDataList);
      }

      const itemDataList = await getViewItem();
      if (itemDataList && itemDataList.length > 0) {
        setItemDataList(itemDataList);
      }

      const whDataList = await getDataWithComp(
        "Tb_Set_WH",
        `AND Flag_Vansale = 'N' AND WH_Status = 'Y' ORDER BY Flag_Vansale, WH_Name ASC`
      );
      if (whDataList && whDataList.length > 0) {
        setWhDataList(whDataList);
      }

      const deposDataList = await getDataWithComp(
        "API_0501_DEPOS_H",
        `AND DocStatus_Name = 'จ่ายมัดจำแล้ว' ORDER BY Doc_No DESC`
      );
      if (deposDataList && deposDataList.length > 0) {
        setDeposDataList(deposDataList);
      }

      const setwh = await getDataWithComp(
        "Tb_Set_WH",
        "and WH_Default_Sale = 'Y'"
      );
      if (setwh && setwh.length > 0) {
        setWhid(setwh?.at(0).WH_Id);
      }

      // สำหรับ View เข้ามาเพื่อแก้ไขข้อมูล
      if (mode === "U") {
        await getModelByNo(apDataList, arDataList, recDataList);
        const matchedDoc = masterList.find((item) => item.Pay_No === maxPayNo);
        const docId = matchedDoc ? matchedDoc?.Pay_Id : null;

        if (docId) {
          const conditions = `DocCode_ID = 4 AND Comp_Id = ${matchedDoc.Comp_Id} AND Doc_ID = ${docId}`;
          const image = await getData("Upload_File_List", conditions);

          // console.debug("image", image);
          if (Array.isArray(image) && image.length > 0) {
            const fileNames = image.map((img) => img.File_Name);

            setSelectedFiles(fileNames);
          } else {
            setSelectedFiles([]);
          }
        } else {
          console.warn("ไม่พบ Doc_ID ที่ตรงกับ maxDocNo");
          setSelectedFiles([]);
        }
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const getModelByNo = async (apDataList, arDataList, recDataList) => {
    try {
      // ค้นหาข้อมูลที่ตรงกับใน AP_ID ใน apDataList
      const findMaster = await getDataWithComp("PAY_H", "");
      const fromDatabase = findMaster.find((pay) => pay.Pay_No === maxPayNo);

      if (!fromDatabase) {
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      // ค้นหาข้อมูลผู้ขายหรือลูกค้าด้วย ID ที่เกี่ยวข้อง
      let fromViewAp, fromViewAr;
      if (fromDatabase.Pay_Type === 3) {
        fromViewAr = apDataList.find((ap) => ap.AP_Id === fromDatabase.AP_Id);
        if (!fromViewAr) {
          throw new Error("ไม่พบข้อมูลลูกค้า");
        }
        const contactBankList =
          arDataList.filter((ar) => ar.AR_Id === fromDatabase.AR_Id)?.[0]
            ?.bankList || [];
        setARContactlist(contactBankList);
      } else {
        fromViewAp = apDataList.find((ap) => ap.AP_Id === fromDatabase.AP_Id);
        if (!fromViewAp) {
          throw new Error("ไม่พบข้อมูลผู้ขาย");
        }
        const contactBankList =
          apDataList.filter((ap) => ap.AP_Id === fromDatabase.AP_Id)?.[0]
            ?.bankList || [];
        setARContactlist(contactBankList);
      }

      // ค้นหาข้อมูล VIEW
      const findViewMaster = await getDataWithComp("API_0401_PAY_H", "");
      const fromView = findViewMaster.find((data) => data.Pay_No === maxPayNo);

      if (fromView) {
        setStatusName(fromView.PayStatus_Name);
        setStatusColour(fromView.PayStatus_Colour);
      }

      // SET ข้อมูลตาม PAY_TYPE
      handleChangePayType(String(fromDatabase.Pay_Type));

      // ถ้าเป็น VAT
      if (fromDatabase.IsVat === 1) {
        setIsVatChecked(true);
      }

      const getWtaxHResponse = await getData(
        "WTAX_H",
        `Ref_PAY_ID = ${fromDatabase.Pay_Id}`
      );
      console.debug("getWtaxHResponse", getWtaxHResponse);
      //
      if (!getWtaxHResponse || getWtaxHResponse.length === 0) {
        console.warn("ไม่พบข้อมูล WTAX_H สำหรับ Pay_Id:", fromDatabase.Pay_Id);
      }
      setSelectedOption(getWtaxHResponse.at(0)?.WTAX_Type);
      const wtaxDResponses = await Promise.all(
        getWtaxHResponse.map(async (wtaxH) => {
          const wtaxId = wtaxH.WTAX_Id;
          return await getData(
            "WTAX_D",
            `WTax_Id = ${wtaxId} ORDER BY "WTAXDT_ID" ASC`
          );
        })
      );

      // ใช้ `flatMap()` แปลงข้อมูล WTAX_D รวมกันทั้งหมด
      const updatedTaxData = wtaxDResponses.flatMap((wtaxDData, index) =>
        wtaxDData.map((item, idx) => ({
          id: index * 100 + idx + 1, // ป้องกัน `id` ซ้ำกัน
          type: item?.WTAX_TypeNo || "",
          percent: item?.WTAX_Percent || 0,
          date: item?.WTAX_Date
            ? moment(item.WTAX_Date).format("DD/MM/YYYY")
            : "",
          amount: item?.WTAX_Pay || 0.0,
          tax: item?.WTAX_Tax || 0,
          remark: item?.WTAX_Desc || "",
        }))
      );
      // อัปเดต state
      setTaxData(updatedTaxData);
      setTotalWT(fromDatabase?.Total_WT);
      setDisTotal(fromDatabase?.Total_Dis_Footer);
      setInputValueTotalWT(parseCurrency(fromDatabase?.Total_WT));
      setInputValuedisTotal(parseCurrency(fromDatabase?.Total_Dis_Footer));

      // ตั้งค่าข้อมูลเอกสารหลัก
      setFormMasterList([
        {
          ...mapDatabaseToFormMasterList(fromDatabase),
          apName:
            fromDatabase.Pay_Type === 3
              ? fromViewAr.AR_Name
              : fromViewAp.AP_Name,
          apAdd1:
            fromDatabase.Pay_Type === 3
              ? fromViewAr.AR_Add1
              : fromViewAp.AP_Add1,
          apAdd2:
            fromDatabase.Pay_Type === 3
              ? fromViewAr.AR_Add2
              : fromViewAp.AP_Add2,
          apAdd3:
            fromDatabase.Pay_Type === 3
              ? fromViewAr.AR_Add3
              : fromViewAp.AP_Add3,
          apProvince:
            fromDatabase.Pay_Type === 3
              ? fromViewAr.AR_Province
              : fromViewAp.AP_Province,
          apZipcode:
            fromDatabase.Pay_Type === 3
              ? fromViewAr.AR_Zipcode
              : fromViewAp.AP_Zipcode,
          apTaxNo:
            fromDatabase.Pay_Type === 3
              ? fromViewAr.AR_TaxNo
              : fromViewAp.AP_TaxNo,
          bank_name: fromDatabase.Bank_Code || "",
          bank_acc_no: fromDatabase.Bank_Acc_No || "",
          bank_acc_name: fromDatabase.Bank_Acc_Name || "",
          fb_Email: fromDatabase.FB_Email || "",
          fb_Telephone: fromDatabase.FB_Telephone || "",
          pay_cheque_bank: fromDatabase.Pay_Cheque_Bank || "",
          pay_cheque_no: fromDatabase.Pay_Cheque_No || "",
        },
      ]);

      setPaymentType({
        cash: fromDatabase.Pay_Trans_Type === 0,
        transfer: fromDatabase.Pay_Trans_Type === 1,
        cheque: fromDatabase.Pay_Trans_Type === 2,
      });
      setChequeBank(fromDatabase.Pay_Cheque_Bank || "");
      setChequeNo(fromDatabase.Pay_Cheque_No || "");

      if (fromDatabase.Pay_Cheque_Date) {
        setChequeDate(
          moment(fromDatabase.Pay_Cheque_Date).format("YYYY-MM-DD")
        );
      }

      if (fromDatabase.Pay_Trans_Date) {
        setTransferDate(
          moment(fromDatabase.Pay_Trans_Date).format("YYYY-MM-DD")
        );
      }

      // ดึงข้อมูลใบแม่และใบลูก (งวดแรก จนถึง งวดอื่นๆ)
      const fromMaster = await getData(
        "PAY_H",
        `Pay_Id = ${fromDatabase?.Pay_Id} AND Ref_DocID IS NULL`
      );
      const fromSubMaster = await getData(
        "PAY_D",
        `Pay_Id = ${fromDatabase?.Pay_Id}`
      );

      let totalPayPer = 0;
      if (fromMaster.length > 0) {
        // กรณีมีใบแม่
        // คำนวณ Total_Pay_Per ของลูก ๆ (เฉพาะที่ Pay_Status = 1)
        if (fromSubMaster.length > 0) {
          for (let i = 0; i < fromSubMaster.length; i++) {
            if (fromMaster[0].Pay_Status !== 2) {
              totalPayPer += parseCurrency(fromSubMaster[i].Item_Total);
            }
          }
        }
        // รวม Total_Pay_Per จากใบแม่ แต่เฉพาะที่ Pay_Status = 1
        if (fromMaster[0].Pay_Status !== 2) {
          totalPayPer += parseCurrency(fromMaster[0].Item_Total);
        }
      } else {
        // กรณีใบลูก
        // ค้นหาใบแม่จาก Ref_DocID ของใบลูก และเอาแม่มาคำนวณด้วย
        const parentId = fromDatabase.Ref_DocID;
        const parentMaster = await getDataWithComp(
          "PAY_H",
          `AND Pay_Id = ${parentId} AND Ref_DocID IS NULL`
        );
        const parentSubMaster = await getDataWithComp(
          "PAY_H",
          `AND Ref_DocID = ${parentMaster[0]?.Pay_Id}`
        );
        if (parentMaster.length > 0) {
          // รวม Total_Pay_Per จากใบลูก แต่เฉพาะที่ Pay_Status = 1
          if (parentSubMaster.length > 0) {
            for (let i = 0; i < parentSubMaster.length; i++) {
              if (parentSubMaster[i].Pay_Status !== 2) {
                totalPayPer += parseCurrency(parentSubMaster[i].Total_Pay_Per);
              }
            }
          }
          // รวม Total_Pay_Per จากใบแม่ แต่เฉพาะที่ Pay_Status = 1
          if (parentMaster[0].Pay_Status !== 2) {
            totalPayPer += parseCurrency(parentMaster[0].Total_Pay_Per);
          }
        }
      }

      // ค้นหาข้อมูลของ Detail ด้วย Doc_ID
      const fromDetail = await getByPayId(
        "PAY_D",
        fromDatabase.Pay_Id,
        `ORDER BY Line ASC`
      );

      if (String(fromDatabase.Pay_Type) === "1" && fromDetail.length > 0) {
        const recSelected = fromDetail
          .map((detail) =>
            recDataList.find(
              (rec) => rec.Rec_ID === parseCurrency(detail.Rec_Id, 10)
            )
          )
          .filter(Boolean);
        await onRowSelectRec(recSelected);
      } else if (
        (String(fromDatabase.Pay_Type) === "2" ||
          String(fromDatabase.Pay_Type) === "3") &&
        fromDetail.length > 0
      ) {
        // ฟังก์ชันเพื่อสร้างโมเดลใหม่สำหรับแต่ละแถวและคำนวณ itemTotal
        const createNewRow = (index, itemSelected) => {
          const itemQty = parseCurrency(itemSelected.Item_Qty) || 0;
          const itemPriceUnit =
            parseCurrency(itemSelected.Item_Price_Unit) || 0;
          const itemDiscount = parseCurrency(itemSelected.Item_Discount) || 0;
          const isPercentageDiscount = itemSelected.Item_DisType === 2;

          let itemTotal = itemQty * itemPriceUnit;

          if (isPercentageDiscount) {
            itemTotal -= (itemDiscount / 100) * itemTotal; // ลดตามเปอร์เซ็นต์
          } else {
            itemTotal -= itemDiscount; // ลดตามจำนวนเงิน
          }

          return {
            ...payDetailModel(index + 1),
            recDtId: itemSelected.DT_Id,
            recId: itemSelected.Rec_ID,
            line: itemSelected.Line,
            itemId: itemSelected.Item_Id,
            recNo: itemSelected.Rec_No,
            itemCode: itemSelected.Item_Code,
            itemName: itemSelected.Item_Name,
            itemQty: formatCurrency(itemQty),
            itemUnit: itemSelected.Item_Unit,
            itemPriceUnit: formatCurrency(itemPriceUnit),
            itemDiscount: formatCurrency(itemDiscount),
            itemDisType: String(itemSelected.Item_DisType),
            itemTotal,
            itemStatus: itemSelected.Item_Status,
            whId: itemSelected.WH_ID,
            whName: itemSelected.WH_Name,
            zoneId: itemSelected.Zone_ID,
            ltId: itemSelected.LT_ID,
            dsSeq: itemSelected.DS_SEQ,
          };
        };

        const newFormDetails = fromDetail.map((item, index) =>
          createNewRow(formDetailList.length + index, item)
        );

        setFormDetailList(newFormDetails);
      } else {
        getAlert(
          "FAILED",
          `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${fromDatabase.Doc_No} กรุณาตรวจสอบและลองอีกครั้ง`
        );
      }
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  const mapDatabaseToFormMasterList = (database) => ({
    docRefType: database.Pay_Type,
    datePay: formatThaiDateUi(database.Doc_PayDate),
    amountPay: formatCurrency(parseCurrency(outstandingBalance)),
    payId: database?.Pay_Id,
    payNo: database.Pay_No,
    payDate: formatThaiDateUi(database.Pay_Date || null),
    docDueDate: formatThaiDateUi(database.Doc_DueDate || null),
    docPayDate: formatThaiDateUi(database.Doc_PayDate || null),
    payStatus: parseCurrency(database.Pay_Status, 10),
    payType: database.Pay_Type,
    refDocID: database.Ref_DocID,
    refDoc: database.Ref_Doc,
    refDocDate: formatThaiDateUi(database.Ref_DocDate),
    compId: database.Comp_Id,
    refProjectID: database.Ref_ProjectID,
    refProjectNo: database.Ref_ProjectNo,
    transportType: database.Transport_Type,
    docRemark1: database.Doc_Remark1,
    docRemark2: database.Doc_Remark2,
    apID: database.AP_Id,
    apCode: database.AP_Code,
    arID: database.AR_Id,
    arCode: database.AR_Code,
    actionHold: database.Action_Hold,
    discountValue: database.Discount_Value,
    discountValueType: database.Discount_Value_Type,
    discountCash: database.Discount_Cash,
    discountCashType: database.Discount_Cash_Type,
    discountTransport: database.Discount_Transport,
    discountTransportType: database.Discount_Transport_Type,
    isVat: database.IsVat,
    docSEQ: database.Doc_SEQ,
    creditTerm: database.CreditTerm,
    creditTerm1Day: database.CreditTerm1Day,
    creditTerm1Remark: database.CreditTerm1Remark,
    creditTerm2Remark: database.CreditTerm2Remark,
    accCode: database.ACC_Code,
    empName: database.EmpName,
    createdDate: setCreateDateTime(database.Created_Date || null),
    createdByName: database.Created_By_Name,
    createdById: database.Created_By_Id,
    updateDate: setCreateDateTime(database.Update_Date || null),
    updateByName: database.Update_By_Name,
    updateById: database.Update_By_Id,
    approvedDate: setCreateDateTime(database.Approved_Date || null),
    approvedByName: database.Approved_By_Name,
    approvedById: database.Approved_By_Id,
    cancelDate: setCreateDateTime(database.Cancel_Date || null),
    cancelByName: database.Cancel_By_Name,
    cancelById: database.Cancel_By_Id,
    approvedMemo: database.Approved_Memo,
    printedStatus: database.Printed_Status,
    printedDate: setCreateDateTime(database.Printed_Date || null),
    printedBy: database.Printed_By,
  });

  const getMaxWtaxNo = async () => {
    const currentYear = moment().year() + 543;
    const shortYear = currentYear.toString().slice(-2);
    const currentMonth = moment().format("MM");
    console.debug(
      "currentYear, shortYear, currentMonth:",
      currentYear,
      shortYear,
      currentMonth
    );

    const prefix = `WT${shortYear}${currentMonth}`;

    // ดึงหมายเลขที่สูงสุดที่มีอยู่ เฉพาะเลขที่ตรงกับ prefix ปัจจุบัน
    const getMaxWtaxNoResponse = await getDataWithComp(
      "WTAX_H",
      `ORDER BY WTAX_Id DESC`
    );

    let newWTaxNo = `${prefix}001`;

    if (getMaxWtaxNoResponse && getMaxWtaxNoResponse.length > 0) {
      const lastWTaxNo = getMaxWtaxNoResponse[0]?.WTAX_No || "";
      // console.debug("🔵 lastWTaxNo:", lastWTaxNo);

      if (/WT\d{4}\d{3}$/.test(lastWTaxNo)) {
        const lastNumber = parseInt(lastWTaxNo.slice(-3), 10) || 0;
        const nextNumber = String(lastNumber + 1).padStart(3, "0");
        newWTaxNo = `${prefix}${nextNumber}`;
      } else {
        console.error("❌ lastWTaxNo format invalid:", lastWTaxNo);
      }
    }

    return newWTaxNo;
  };

  const updateWtaxRecords = async (payId, taxData) => {
    try {
      let getWtaxIdResponse = await getDataWithComp(
        "WTAX_H",
        `AND Ref_PAY_ID = ${payId}`
      );

      // ถ้าไม่มี WTAX_H มาก่อน ให้สร้างใหม่
      if (!getWtaxIdResponse || getWtaxIdResponse.length === 0) {
        console.log("❗ ไม่พบ WTAX_H จะสร้างใหม่...");

        for (const taxItem of taxData) {
          if (
            !taxItem.amount ||
            parseFloat(parseCurrency(taxItem.amount)) === 0
          ) {
            console.warn(
              "⚠ ข้ามการสร้าง WTAX_H เพราะ amount เป็น 0 หรือไม่ถูกต้อง",
              taxItem
            );
            continue;
          }

          const newWTaxNo = await getMaxWtaxNo(); // สร้าง WTax_No ใหม่

          const wtaxHData = {
            WTax_No: newWTaxNo,
            Ref_Doc: maxPayNo,
            AP_Id: formMasterList[0].apID,
            Ref_PAY_ID: payId,
            WTax_Type: selectedOption,
            WTax_Total: parseFloat(parseCurrency(taxItem.amount)).toFixed(2),
            WTax_Total_Tax: parseFloat(parseCurrency(taxItem.tax)).toFixed(2),
            WTax_Created_Date: moment().add(7, "hours").toDate(),
            WTax_Created_By: window.localStorage.getItem("name"),
            Comp_Id: window.localStorage.getItem("company"),
            WTAX_Status: 1,
          };

          const insertWtaxHRes = await insertData(
            "WTAX_H",
            Object.keys(wtaxHData).join(", "),
            Object.values(wtaxHData)
          );

          if (insertWtaxHRes?.status !== "OK") {
            getAlert("FAILED", "ไม่สามารถสร้าง WTAX_H ใหม่ได้");
            return;
          }

          // ดึง WTAX_Id ที่สร้างขึ้น
          getWtaxIdResponse = await getDataWithComp(
            "WTAX_H",
            `AND WTax_No = '${newWTaxNo}'`
          );
        }
      }

      // อัปเดตข้อมูล WTAX_H ที่มีอยู่
      for (const [index, wtaxH] of getWtaxIdResponse.entries()) {
        if (index >= taxData.length) {
          console.warn(
            `❗ ไม่มี taxData สำหรับ WTax_Id: ${wtaxH.WTAX_Id}, ข้ามการอัปเดต`
          );
          continue;
        }

        const wtaxId = wtaxH.WTAX_Id;
        const relevantTaxItem = taxData[index];

        if (
          !relevantTaxItem ||
          parseFloat(parseCurrency(relevantTaxItem.amount || 0)) === 0
        ) {
          console.warn(
            `⚠ ข้ามการ insertData WTAX_D เพราะ amount เป็น 0 หรือข้อมูลไม่ถูกต้อง`,
            relevantTaxItem
          );
          continue;
        }

        const wtaxHData = {
          Ref_Doc: maxPayNo,
          AP_Id: formMasterList[0].apID,
          Ref_PAY_ID: payId,
          WTax_Type: selectedOption,
          WTax_Total: parseFloat(parseCurrency(relevantTaxItem.amount)).toFixed(
            2
          ),
          WTax_Total_Tax: parseFloat(
            parseCurrency(relevantTaxItem.tax)
          ).toFixed(2),
          WTax_Updated_Date: moment().add(7, "hours").toDate(),
          WTax_Updated_By: window.localStorage.getItem("name"),
        };

        await updateData("WTAX_H", wtaxHData, { WTax_Id: wtaxId });
        await deleteData("WTAX_D", `WHERE WTax_Id = ${wtaxId}`);

        const wtaxDData = {
          WTax_Id: wtaxId,
          WTax_TypeNo: relevantTaxItem.type,
          WTax_Desc: relevantTaxItem.remark || "",
          WTax_Percent: parseFloat(parseCurrency(relevantTaxItem.percent)),
          WTax_Date: relevantTaxItem.date
            ? moment(relevantTaxItem.date, "DD/MM/YYYY")
              .add(7, "hours")
              .toDate()
            : moment().add(7, "hours").toDate(),
          WTax_Pay: parseFloat(parseCurrency(relevantTaxItem.amount)).toFixed(
            2
          ),
          WTax_Tax: parseFloat(parseCurrency(relevantTaxItem.tax)).toFixed(2),
        };

        try {
          const insertResult = await insertData(
            "WTAX_D",
            Object.keys(wtaxDData).join(", "),
            Object.values(wtaxDData)
          );
          console.debug("✅ insertData สำเร็จ:", insertResult);
        } catch (error) {
          console.error("❌ insertData ล้มเหลว:", error);
        }
      }
    } catch (error) {
      getAlert("FAILED", "เกิดข้อผิดพลาดในการอัปเดต WTAX");
      console.error(error);
    }
  };

  const handleSubmit = async () => {
    try {
      // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode
      if (
        (parseCurrency(docRefType) === 1 || parseCurrency(docRefType) === 2) &&
        !formMasterList[0].apID &&
        !formMasterList[0].apCode
      ) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบผู้ขาย");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
      }
      if (
        parseCurrency(docRefType) === 3 &&
        !formMasterList[0].apID &&
        !formMasterList[0].apCode
      ) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบลูกค้า");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า arID หรือ arCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบว่ามีการเลือกวันที่ครบทุกงวดหรือไม่ และ ต้องห้ามเป็นวันเดียวกัน
      let dateSet = new Set();
      for (let i = 0; i < formMasterList.length; i++) {
        if (!formMasterList[i].datePay) {
          getAlert("FAILED", "กรุณาเลือกวันที่จ่ายงวดที่ " + (i + 1));
          return; // หยุดการทำงานของฟังก์ชันหากมีงวดที่ไม่มีการเลือกวันที่
        }

        if (formMasterList[i].datePay) {
          let datePay = formMasterList[i].datePay;

          // ตรวจสอบวันที่จ่าย ต้องห้ามเป็นวันเดียวกัน
          if (dateSet.has(datePay)) {
            getAlert(
              "FAILED",
              "วันที่จ่ายงวดที่ " +
              (i + 1) +
              " ซ้ำกับวันที่จ่ายในงวดก่อนหน้านี้"
            );
            return; // หยุดการทำงานของฟังก์ชันหากวันที่ซ้ำ
          }

          dateSet.add(datePay);
        }
      }

      // ตรวจสอบจำนวนยอดทั้งหมด ต้องไม่เกินราคารวม
      let totalAmountPay = 0;
      for (let i = 0; i < formMasterList.length; i++) {
        // แปลงค่าจากสตริงให้เป็นตัวเลข
        let amountPay = parseCurrency(
          formMasterList[i].amountPay.replace(/,/g, "")
        );
        totalAmountPay += amountPay;
      }

      // ตรวจสอบว่าจำนวนยอดทั้งหมดไม่เกินและไม่น้อยกว่ายอดที่ต้องชำระ
      if (
        parseCurrency(totalAmountPay.toFixed(2)) >
        parseCurrency(outstandingBalance.toFixed(2))
      ) {
        getAlert("FAILED", `ไม่สามารถจ่ายเกินยอดได้`);
        return; // หยุดการทำงานของฟังก์ชันหากมีงวดที่ยอดเงินเกิน
      }

      if (
        parseCurrency(totalAmountPay.toFixed(2)) <
        parseCurrency(outstandingBalance.toFixed(2))
      ) {
        getAlert("FAILED", `ไม่สามารถจ่ายต่ำกว่ายอดได้`);
        return; // หยุดการทำงานของฟังก์ชันหากมีงวดที่ยอดเงินต่ำกว่า
      }

      // ใบจ่าย Set วันที่ชำระ แต่ละใบเป็นวันที่ใบรับ ที่น้อยที่สุด + CreditTerm (ดักเฉพาะกรณีที่บันทึกใบจ่ายด้วยใบรับ)
      let newDocDueDate = formMasterList[0].docDueDate;
      // if (parseCurrency(docRefType) === 1) {
      //     // แปลงวันที่ไทยให้เป็นวันที่ที่ Moment เข้าใจ
      //     let minDateMoment = moment(newDocDueDate, 'DD-MM-YYYY');

      //     // เพิ่ม CreditTerm เข้าไปในวันที่ใบรับที่น้อยที่สุด
      //     newDocDueDate = minDateMoment.add(creditTerm, 'days').format('DD-MM-YYYY');
      // }

      // หาค่าสูงสุดของ PayNo ใน PAY_H ก่อนบันทึก
      let dateString = formMasterList[0].datePay;
      let givenDate =
        "PAY" +
        dateString.substring(6, 10).substring(2) +
        dateString.substring(3, 5);

      // ทดสอบหน่วงเวลาก่อนบันทึก (ทดสอบป้องกันการซ้ำของ Doc_No)
      await randomDelay();

      const findMaxPayNo = await getDataWithComp(
        "PAY_H",
        "ORDER BY Pay_No DESC"
      );
      const maxPay = getMaxPayNo(findMaxPayNo, dateString);
      let newMaxPay = maxPay;

      // เก็บข้อมูลสำหรับใบแรกไว้เสมอ เช่น Ref_DocID, Ref_Doc, Ref_DocDate
      const incrementedPayNo = incrementPayNoWithIndex(newMaxPay, 0);
      let refDocID = null;
      let refDoc = incrementedPayNo;
      let refDocDate = formMasterList[0].payDate || null;

      // บันทึก formMasterList[0] ก่อน
      formMasterList[0].pay_cheque_bank = chequeBank;
      formMasterList[0].pay_cheque_no = chequeNo;
      const formData = {
        pay_no: incrementedPayNo,
        pay_date: formatStringDateToDate(formMasterList[0].payDate),
        doc_due_date: formatStringDateToDate(newDocDueDate),
        doc_pay_date: formatStringDateToDate(formMasterList[0].datePay),
        pay_status: parseCurrency("1", 10),
        pay_type: parseCurrency(docRefType, 10),
        ref_doc_id: formMasterList[0].refDocID,
        ref_doc:
          parseCurrency(docRefType) === 3
            ? formMasterList[0].refDoc
            : formMasterList[0].refDoc,
        ref_doc_date: null,
        comp_id: window.localStorage.getItem("company"),
        ref_project_id: formMasterList[0].refProjectID,
        ref_project_no: formMasterList[0].refProjectNo,
        transport_type: formMasterList[0].transportType,
        doc_remark1: formMasterList[0].docRemark1,
        doc_remark2: formMasterList[0].docRemark2,
        ap_id: formMasterList[0].apID,
        ap_code: formMasterList[0].apCode,
        ar_id: formMasterList[0].arID,
        ar_code: formMasterList[0].arCode,
        action_hold: parseCurrency("0", 10),
        discount_value: parseCurrency(formMasterList[0].discountValue || 0.0),
        discount_value_type: parseCurrency(selectedDiscountValueType, 10),
        discount_cash: parseCurrency("0.00"),
        discount_cash_type: formMasterList[0].discountCashType,
        discount_transport: parseCurrency("0.00"),
        discount_transport_type: formMasterList[0].discountTransportType,
        is_vat: isVatChecked ? parseCurrency("1") : parseCurrency("2"),
        doc_seq: formatDateTime(new Date()),
        credit_term: parseCurrency("0", 10),
        credit_term_1_day: parseCurrency("0", 10),
        credit_term_1_remark: formMasterList[0].creditTerm1Remark,
        credit_term_2_remark: formMasterList[0].creditTerm2Remark,
        acc_code: "0000",
        emp_name: null,
        created_date: formatThaiDateUiToDate(formMasterList[0].createdDate),
        created_by_name: window.localStorage.getItem("name"),
        created_by_id: window.localStorage.getItem("emp_id"),
        update_date: null,
        update_by_name: null,
        update_by_id: null,
        approved_date: null,
        approved_by_name: null,
        approved_by_id: null,
        cancel_date: null,
        cancel_by_name: null,
        cancel_by_id: null,
        approved_memo: null,
        printed_status: "N",
        printed_date: null,
        printed_by: null,
        cancel_memo: null,
        total_pay_per: parseCurrency(grandTotal),
        total_wt: totalWT,
        isWTAX: taxData.some((item) => parseCurrency(item.amount) > 0)
          ? "Y"
          : "N",
        total_dis_footer: parseCurrency(disTotal),
        total_pay_netTotal: parseCurrency(FinalTotal),
        bank_code: formMasterList[0].bank_name || "",
        bank_acc_no: formMasterList[0].bank_acc_no || "",
        bank_acc_name: formMasterList[0].bank_acc_name || "",
        fb_email: formMasterList[0]?.fb_Email || "",
        fb_telephone: formMasterList[0]?.fb_Telephone || "",
        pay_trans_type: getPayTransType(),
        pay_cheque_bank: formMasterList[0].pay_cheque_bank || "",
        pay_cheque_no: formMasterList[0].pay_cheque_no || "",
        pay_cheque_date: chequeDate ? new Date(chequeDate) : null,
        pay_trans_date: transferDate ? new Date(transferDate) : null,
      };

      const firstResponse = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-pay-h`,
        formData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (firstResponse.data.status !== "OK") {
        getAlert("FAILED", "ไม่สามารถบันทึกข้อมูลรายการแรกได้");
        return;
      }

      // Fetch ข้อมูลสำหรับ Ref_DocID
      const getPayIdResponse = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/get-by-pay-no`,
        {
          table: "PAY_H",
          pay_no: incrementedPayNo,
          comp_id: window.localStorage.getItem("company"),
        },
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // เก็บ Pay_Id ของใบแรกเอาไว้ใน refDocID และทำการบันทึก Detail ของใบแรกไปก่อน
      if (getPayIdResponse && getPayIdResponse.data.length > 0) {
        refDocID = getPayIdResponse.data[0]?.Pay_Id;

        const detailPromises = formDetailList.map(async (item, index) => {
          let payId = parseCurrency(getPayIdResponse.data[0]?.Pay_Id, 10);

          const formDetailData = {
            pay_id: payId,
            rec_dt_id: item.recDtId,
            rec_id: item.recId,
            line: index + 1,
            item_id: item.itemId,
            item_code: item.itemCode,
            item_name: item.itemName,
            item_qty: parseCurrency(item.itemQty),
            item_unit: item.itemUnit,
            item_price_unit: parseCurrency(item.itemPriceUnit),
            item_discount: parseCurrency(item.itemDiscount),
            item_distype:
              item.itemDisType === "1"
                ? parseCurrency("1", 10)
                : parseCurrency("2", 10),
            item_total: parseCurrency(item.itemTotal),
            item_status: parseCurrency("1", 10),
            wh_id: parseCurrency(item.whId, 10),
            zone_id: parseCurrency("1", 10),
            lt_id: parseCurrency("1", 10),
            ds_seq: formatDateTime(new Date()),
          };
          console.debug("🔥 formDetailData:", formDetailData);

          // ยอดสถานะค้างจ่ายของใบรับสินค้า
          await updateStatusByNo(
            "REC_H", // table: ชื่อตาราง
            "Doc_Status_Paid", // field: ชื่อฟิลด์
            1, // status: สถานะที่ต้องการอัพเดท
            `WHERE Rec_ID = '${item.recId}'` // where: เงื่อนไขในการอัพเดท
          );

          return Axios.post(
            `${process.env.REACT_APP_API_URL}/api/create-pay-d`,
            formDetailData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );
        });

        await Promise.all(detailPromises);
        if (selectedFiles.length > 0) {
          try {
            const imageSources = selectedFiles.map((file) => file);
            const compId = window.localStorage.getItem("company");
            const payId = refDocID;
            const DocCode_ID = 4;
            const emp_name = window.localStorage.getItem("name");
            const file_status = "Y";

            const response = await Axios.post(
              `${process.env.REACT_APP_API_URL}/api/upload-file`,
              {
                comp_id: compId,
                doc_id: payId,
                DocCode_ID,
                upload_by: emp_name,
                file_status,
                files: imageSources,
              }
            );
            console.debug(response);
            if (response.data.status !== "SUCCESS") {
              console.error("อัปโหลดไฟล์ล้มเหลว:", response.data.message);
              getAlert("FAILED", "อัปโหลดไฟล์ล้มเหลว กรุณาลองใหม่อีกครั้ง");
            }
          } catch (error) {
            console.error("เกิดข้อผิดพลาดขณะอัปโหลดไฟล์:", error);
            getAlert("FAILED", "เกิดข้อผิดพลาดขณะอัปโหลดไฟล์");
          }
        }
      } else {
        console.error("ไม่สามารถรับข้อมูล Pay_Id ได้");
        return;
      }

      // *********************************************************************************************
      // ถ้า formMasterList มีมากกว่า 1 ข้อมูล และให้เริ่มต้นบันทึกแต่ข้อมูลที่ [1] เป็นต้นไป
      if (formMasterList.length > 1) {
        for (let i = 1; i < formMasterList.length; i++) {
          // ใบจ่าย Set วันที่ชำระ แต่ละใบเป็นวันที่ใบรับ ที่น้อยที่สุด + CreditTerm (ดักเฉพาะกรณีที่บันทึกใบจ่ายด้วยใบรับ)
          // if (parseCurrency(docRefType) === 1) {
          //     // สมมติว่า `minReceiptDate` คือวันที่ใบรับที่น้อยที่สุด
          //     let minReceiptDate = newDocDueDate;

          //     // แปลงวันที่ไทยให้เป็นวันที่ที่ Moment เข้าใจ
          //     let minDateMoment = moment(minReceiptDate, 'DD-MM-YYYY');

          //     // เพิ่ม CreditTerm เข้าไปในวันที่ใบรับที่น้อยที่สุด
          //     newDocDueDate = minDateMoment.add(creditTerm, 'days').format('DD-MM-YYYY');
          // }

          // บันทึก Master
          let formMasterData = formMasterList[i];

          // หาค่าสูงสุดของ PayNo ใน PAY_H ก่อนบันทึก
          let dateString = formMasterList[i].datePay;
          let givenDate =
            "PAY" +
            dateString.substring(6, 10).substring(2) +
            dateString.substring(3, 5);
          const findMaxPayNo = await getDataWithComp(
            "PAY_H",
            "ORDER BY Pay_No DESC"
          );
          const maxPay = getMaxPayNo(findMaxPayNo, dateString);
          let incrementedPayNo = maxPay;

          // บันทึกรายการที่เหลือใน formMasterList
          let formData = {
            pay_no: incrementedPayNo,
            pay_date: formatStringDateToDate(formMasterData.payDate),
            doc_due_date: formatStringDateToDate(formMasterData.datePay),
            doc_pay_date: formatStringDateToDate(formMasterData.datePay),
            pay_status: parseCurrency("1", 10),
            pay_type: parseCurrency(docRefType, 10),
            ref_doc_id: formMasterList.refDocID,
            ref_doc: formMasterList.refDoc,
            ref_doc_date: formatThaiDateUiToDate(refDocDate),
            comp_id: window.localStorage.getItem("company"),
            ref_project_id: formMasterData.refProjectID,
            ref_project_no: formMasterData.refProjectNo,
            transport_type: formMasterData.transportType,
            doc_remark1: formMasterData.docRemark1,
            doc_remark2: formMasterData.docRemark2,
            ap_id: formMasterData.apID,
            ap_code: formMasterData.apCode,
            ar_id: formMasterData.arID,
            ar_code: formMasterData.arCode,
            action_hold: parseCurrency("0", 10),
            discount_value: parseCurrency(formMasterData.discountValue || 0.0),
            discount_value_type: parseCurrency(selectedDiscountValueType, 10),
            discount_cash: parseCurrency("0.00"),
            discount_cash_type: formMasterData.discountCashType,
            discount_transport: parseCurrency("0.00"),
            discount_transport_type: formMasterData.discountTransportType,
            is_vat: isVatChecked ? parseCurrency("1") : parseCurrency("2"),
            doc_seq: formatDateTime(new Date()),
            credit_term: parseCurrency("0", 10),
            credit_term_1_day: parseCurrency("0", 10),
            credit_term_1_remark: formMasterData.creditTerm1Remark,
            credit_term_2_remark: formMasterData.creditTerm2Remark,
            acc_code: "0000",
            emp_name: null,
            created_date: formatThaiDateUiToDate(formMasterData.createdDate),
            created_by_name: window.localStorage.getItem("name"),
            created_by_id: window.localStorage.getItem("emp_id"),
            update_date: null,
            update_by_name: null,
            update_by_id: null,
            approved_date: null,
            approved_by_name: null,
            approved_by_id: null,
            cancel_date: null,
            cancel_by_name: null,
            cancel_by_id: null,
            approved_memo: null,
            printed_status: "N",
            printed_date: null,
            printed_by: null,
            cancel_memo: null,
            total_pay_per: parseCurrency(formMasterData.amountPay),
            fb_email: formMasterData.fb_Email || "",
            fb_telephone: formMasterData.fb_Telephone || "",
          };

          let additionalResponse = await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/create-pay-h`,
            formData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );

          if (additionalResponse.data.status !== "OK") {
            getAlert("FAILED", "ไม่สามารถบันทึกรายการที่เหลือได้");
            return;
          }

          let getPayIdResponse = await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/get-by-pay-no`,
            {
              table: "PAY_H",
              pay_no: incrementedPayNo,
              comp_id: window.localStorage.getItem("company"),
            },
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );

          if (getPayIdResponse && getPayIdResponse.data.length > 0) {
            let detailPromises = formDetailList.map((item, index) => {
              let payId = parseCurrency(getPayIdResponse.data[0]?.Pay_Id, 10);

              let formDetailData = {
                pay_id: payId,
                rec_dt_id: item.recDtId,
                rec_id: item.recId,
                line: index + 1,
                item_id: item.itemId,
                item_code: item.itemCode,
                item_name: item.itemName,
                item_qty: parseCurrency(item.itemQty),
                item_unit: item.itemUnit,
                item_price_unit: parseCurrency(item.itemPriceUnit),
                item_discount: parseCurrency(item.itemDiscount),
                item_distype:
                  item.itemDisType === "1"
                    ? parseCurrency("1", 10)
                    : parseCurrency("2", 10),
                item_total: parseCurrency(item.itemTotal),
                item_status: item.itemStatus,
                wh_id: parseCurrency(item.whId, 10),
                zone_id: parseCurrency("1", 10),
                lt_id: parseCurrency("1", 10),
                ds_seq: formatDateTime(new Date()),
              };
              console.debug("🔥 formDetailData", formDetailData);

              return Axios.post(
                `${process.env.REACT_APP_API_URL}/api/create-pay-d`,
                formDetailData,
                {
                  headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
                }
              );
            });

            await Promise.all(detailPromises);
          }
        }
      }
      const validTaxData = taxData.filter(
        (item) => parseCurrency(item.amount) > 0
      );

      if (validTaxData.length === 0) {
        callInitialize();
        getAlert("OK", "บันทึกข้อมูลสำเร็จ");
        // getAlert("FAILED", "ไม่มีข้อมูลที่สามารถสร้าง WTAX_H ได้");
        return;
      }

      for (const taxItem of validTaxData) {
        const newWTaxNo = await getMaxWtaxNo(); // สร้าง WTax_No ใหม่สำหรับแต่ละใบ

        const wtaxHData = {
          WTax_No: newWTaxNo,
          Ref_PAY_ID: refDocID,
          AP_Id: formMasterList[0].apID,
          Ref_Doc: maxPayNo,
          WTax_Type: selectedOption,
          WTax_Total: parseCurrency(taxItem.amount).toFixed(2), // ทศนิยมเข้า DB
          WTax_Total_Tax: parseCurrency(taxItem.tax).toFixed(2),
          WTax_Created_Date: moment().add(7, "hours").toDate(),
          WTax_Created_By: window.localStorage.getItem("name"),
          WTax_Updated_Date: null,
          WTax_Updated_By: null,
          Comp_Id: window.localStorage.getItem("company"),
          WTAX_Status: 1,
        };

        const insertWtaxHRes = await insertData(
          "WTAX_H",
          Object.keys(wtaxHData).join(", "),
          Object.values(wtaxHData)
        );

        if (insertWtaxHRes?.status !== "OK") {
          getAlert(
            "FAILED",
            "ไม่สามารถบันทึกข้อมูลภาษีหัก ณ ที่จ่าย (WTAX_H) ได้"
          );
          return;
        }

        // ดึง WTAX_Id ที่สร้างขึ้น
        const getWtaxIdResponse = await getDataWithComp(
          "WTAX_H",
          `And WTax_No = '${newWTaxNo}'`
        );

        if (!getWtaxIdResponse || getWtaxIdResponse.length === 0) {
          getAlert("FAILED", "ไม่พบ WTax_Id ที่ถูกสร้างขึ้น");
          return;
        }

        const wtaxId = getWtaxIdResponse[0].WTAX_Id;

        // บันทึก WTAX_D สำหรับ WTAX_H แต่ละใบ
        const wtaxDData = {
          WTax_Id: wtaxId,
          WTax_TypeNo: taxItem.type,
          WTax_Desc: taxItem.remark || "",
          WTax_Percent: parseCurrency(taxItem.percent),
          WTax_Date: moment(taxItem.date, "DD/MM/YYYY")
            .add(7, "hours")
            .toDate(),
          WTax_Pay: parseFloat(parseCurrency(taxItem.amount)).toFixed(2),
          WTax_Tax: parseFloat(parseCurrency(taxItem.tax)).toFixed(2),
        };

        const insertWtaxDRes = await insertData(
          "WTAX_D",
          Object.keys(wtaxDData).join(", "),
          Object.values(wtaxDData)
        );

        if (insertWtaxDRes?.status !== "OK") {
          getAlert("FAILED", "ไม่สามารถบันทึกข้อมูล WTAX_D ได้");
          return;
        }
      }
      // จบกระบวนการทุกอย่างแบบสมบูรณ์
      callInitialize();
      getAlert("OK", "บันทึกข้อมูลสำเร็จ");
    } catch (error) {
      getAlert("FAILED", "เกิดข้อผิดพลาดในการบันทึกข้อมูล");
    }
  };

  const handleUpdate = async () => {
    try {
      // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode
      if (
        (parseCurrency(docRefType) === 1 || parseCurrency(docRefType) === 2) &&
        !formMasterList[0].apID &&
        !formMasterList[0].apCode
      ) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบผู้ขาย");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
      }
      if (
        parseCurrency(docRefType) === 3 &&
        !formMasterList[0].arID &&
        !formMasterList[0].arCode
      ) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบลูกค้า");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า arID หรือ arCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบว่ามีการเลือกวันที่ครบทุกงวดหรือไม่
      for (let i = 0; i < formMasterList.length; i++) {
        if (!formMasterList[i].datePay) {
          getAlert("FAILED", "กรุณาเลือกวันที่จ่ายงวดที่ " + (i + 1));
          return; // หยุดการทำงานของฟังก์ชันหากมีงวดที่ไม่มีการเลือกวันที่
        }
      }

      // ตรวจสอบจำนวนยอดทั้งหมด ต้องไม่เกินราคารวม
      let totalAmountPay = 0;
      for (const master of formMasterList) {
        if (master.amountPay) {
          totalAmountPay += parseCurrency(master.amountPay) || 0;
        }
      }
      if (
        parseCurrency(totalAmountPay.toFixed(2)) >
        parseCurrency(grandTotal.toFixed(2))
      ) {
        getAlert("FAILED", `ไม่สามารถจ่ายเกินยอดได้`);
      }

      // แก้ไขเฉพาะใบแรกก่อน
      formMasterList[0].pay_cheque_bank = chequeBank;
      formMasterList[0].pay_cheque_no = chequeNo;
      const formMasterData = {
        pay_no: maxPayNo,
        pay_date: formatStringDateToDate(formMasterList[0].payDate),
        doc_due_date: formatStringDateToDate(formMasterList[0].docDueDate),
        doc_pay_date: formatStringDateToDate(formMasterList[0].datePay),
        pay_status: parseCurrency("1", 10),
        pay_type: parseCurrency(docRefType, 10),
        ref_doc_id: formMasterList[0].refDocID,
        ref_doc: formMasterList[0].refDoc,
        ref_doc_date: formatThaiDateUiToDate(formMasterList[0].refDocDate),
        comp_id: formMasterList[0].compId,
        ref_project_id: formMasterList[0].refProjectID,
        ref_project_no: formMasterList[0].refProjectNo,
        doc_remark1: formMasterList[0].docRemark1,
        doc_remark2: formMasterList[0].docRemark2,
        ap_id: parseCurrency(formMasterList[0].apID, 10),
        ap_code: formMasterList[0].apCode,
        ar_id: parseCurrency(formMasterList[0].arID, 10),
        ar_code: formMasterList[0].arCode,
        action_hold: parseCurrency(formMasterList[0].actionHold, 10),
        discount_value: parseCurrency(formMasterList[0].discountValue || 0.0),
        discount_value_type: parseCurrency(selectedDiscountValueType, 10),
        discount_cash: parseCurrency(formMasterList[0].discountCash),
        discount_cash_type: formMasterList[0].discountCashType,
        discount_transport: parseCurrency(formMasterList[0].discountTransport),
        discount_transport_type: formMasterList[0].discountTransportType,
        is_vat: isVatChecked ? parseCurrency("1") : parseCurrency("2"),
        doc_seq: formMasterList[0].docSEQ,
        credit_term: parseCurrency(formMasterList[0].creditTerm, 10),
        credit_term_1_day: parseCurrency(formMasterList[0].creditTerm1Day, 10),
        credit_term_1_remark: formMasterList[0].creditTerm1Remark,
        credit_term_2_remark: formMasterList[0].creditTerm2Remark,
        acc_code: formMasterList[0].accCode,
        emp_name: formMasterList[0].empName,
        created_date: formatThaiDateUiToDate(formMasterList[0].createdDate),
        created_by_name: formMasterList[0].createdByName,
        created_by_id: formMasterList[0].createdById,
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        approved_date: null,
        approved_by_name: null,
        approved_by_id: null,
        cancel_date: null,
        cancel_by_name: null,
        cancel_by_id: null,
        approved_memo: null,
        printed_status: "N",
        printed_date: null,
        printed_by: null,
        cancel_memo: null,
        total_pay_per: parseCurrency(grandTotal),
        total_wt: totalWT,
        isWTAX: taxData.some((item) => parseCurrency(item.amount) > 0)
          ? "Y"
          : "N",
        total_dis_footer: parseCurrency(disTotal),
        total_pay_netTotal: parseCurrency(FinalTotal),
        bank_code: formMasterList[0].bank_name || "",
        bank_acc_no: formMasterList[0].bank_acc_no || "",
        bank_acc_name: formMasterList[0].bank_acc_name || "",
        fb_email: formMasterList[0]?.fb_Email || "",
        fb_telephone: formMasterList[0]?.fb_Telephone || "",
        pay_trans_type: getPayTransType(),
        pay_cheque_bank: formMasterList[0].pay_cheque_bank || "",
        pay_cheque_no: formMasterList[0].pay_cheque_no || "",
        pay_cheque_date: chequeDate ? new Date(chequeDate) : null,
        pay_trans_date: transferDate ? new Date(transferDate) : null,
      };
      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-pay-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // #####################################
      // DELETE PAY_D เฉพาะรายการเดียว
      const payId = parseCurrency(formMasterList[0].payId, 10);
      await deleteData("PAY_D", `WHERE Pay_Id = ${payId}`);
      // #####################################

      const detailPromises = formDetailList.map((item, index) => {
        const formDetailData = {
          pay_id: payId,
          rec_dt_id: item.recDtId,
          rec_id: item.recId,
          line: index + 1,
          item_id: item.itemId,
          item_code: item.itemCode,
          item_name: item.itemName,
          item_qty: parseCurrency(item.itemQty),
          item_unit: item.itemUnit,
          item_price_unit: parseCurrency(item.itemPriceUnit),
          item_discount: parseCurrency(item.itemDiscount),
          item_distype:
            item.itemDisType === "1"
              ? parseCurrency("1", 10)
              : parseCurrency("2", 10),
          item_total: parseCurrency(item.itemTotal),
          item_status: parseCurrency("1", 10),
          wh_id: parseCurrency(item.whId, 10),
          zone_id: parseCurrency("1", 10),
          lt_id: parseCurrency("1", 10),
          ds_seq: formatDateTime(new Date()),
        };

        return Axios.post(
          `${process.env.REACT_APP_API_URL}/api/create-pay-d`,
          formDetailData,
          {
            headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
          }
        );
      });
      await Promise.all(detailPromises);
      await updateWtaxRecords(payId, taxData);

      if (selectedFiles.length > 0) {
        try {
          // กรองไฟล์ที่ไม่ใช่ลิงก์
          const filteredFiles = selectedFiles.filter(
            (file) =>
              !file.startsWith(
                "https://encotech.s3.ap-southeast-1.amazonaws.com/"
              )
          );

          const compId = window.localStorage.getItem("company");
          const payId = payId;
          const DocCode_ID = 4;
          const emp_name = window.localStorage.getItem("name");
          const file_status = "Y";

          console.debug("response", {
            comp_id: compId,
            doc_id: payId,
            DocCode_ID,
            upload_by: emp_name,
            file_status,
            files: filteredFiles, // ส่งไฟล์ที่กรองแล้ว
          });

          const response = await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/upload-file`,
            {
              comp_id: compId,
              doc_id: payId,
              DocCode_ID,
              upload_by: emp_name,
              file_status,
              files: filteredFiles, // ส่งไฟล์ที่กรองแล้ว
            }
          );

          if (response.data.status !== "SUCCESS") {
            console.error("อัปโหลดไฟล์ล้มเหลว:", response.data.message);
            getAlert("FAILED", "อัปโหลดไฟล์ล้มเหลว กรุณาลองใหม่อีกครั้ง");
          }
        } catch (error) {
          console.error("เกิดข้อผิดพลาดขณะอัปโหลดไฟล์:", error);
          getAlert("FAILED", "เกิดข้อผิดพลาดขณะอัปโหลดไฟล์");
        }
      }

      // อย่าลบนะ เสียดายโค้ดหว่ะ

      // *********************************************************************************************
      // ถ้า formMasterList มีมากกว่า 1 ข้อมูล และให้เริ่มต้นบันทึกแต่ข้อมูลที่ [1] เป็นต้นไป
      // if (formMasterList.length > 1) {
      //     for (let i = 1; i < formMasterList.length; i++) {
      //         // บันทึก Master
      //         let formMasterData = formMasterList[i];

      //         // หาค่าสูงสุดของ PayNo ใน PAY_H ก่อนบันทึก
      //         let dateString = formMasterList[i].datePay;
      //         let givenDate = "PAY" + dateString.substring(6, 10).substring(2) + dateString.substring(3, 5);
      //         const findMaxPayNo = await getDataWithComp('PAY_H', `AND Pay_No LIKE '${givenDate}%' ORDER BY Pay_No DESC`);
      //         const maxPay = getMaxPayNo(findMaxPayNo, dateString);
      //         let incrementedPayNo = maxPay;

      //         // บันทึกรายการที่เหลือใน formMasterList
      //         let formData = {
      //             pay_no: incrementedPayNo,
      //             pay_date: formatStringDateToDate(formMasterData.payDate),
      //             doc_due_date: formatStringDateToDate(formMasterData.datePay),
      //             pay_status: parseCurrency("1", 10),
      //             pay_type: parseCurrency(docRefType, 10),
      //             ref_doc_id: refDocID,
      //             ref_doc: refDoc,
      //             ref_doc_date: formatThaiDateUiToDate(refDocDate),
      //             comp_id: window.localStorage.getItem('company'),
      //             ref_project_id: formMasterData.refProjectID,
      //             ref_project_no: formMasterData.refProjectNo,
      //             transport_type: formMasterData.transportType,
      //             doc_remark1: formMasterData.docRemark1,
      //             doc_remark2: formMasterData.docRemark2,
      //             ap_id: parseCurrency(formMasterData.apID, 10),
      //             ap_code: formMasterData.apCode,
      //             action_hold: parseCurrency("0", 10),
      //             discount_value: parseCurrency(formMasterData.discountValue || 0.00),
      //             discount_value_type: parseCurrency(selectedDiscountValueType, 10),
      //             discount_cash: parseCurrency("0.00"),
      //             discount_cash_type: formMasterData.discountCashType,
      //             discount_transport: parseCurrency("0.00"),
      //             discount_transport_type: formMasterData.discountTransportType,
      //             is_vat: isVatChecked ? parseCurrency("1") : parseCurrency("2"),
      //             doc_seq: formatDateTime(new Date()),
      //             credit_term: parseCurrency("0", 10),
      //             credit_term_1_day: parseCurrency("0", 10),
      //             credit_term_1_remark: formMasterData.creditTerm1Remark,
      //             credit_term_2_remark: formMasterData.creditTerm2Remark,
      //             acc_code: "0000",
      //             emp_name: null,
      //             created_date: formatThaiDateUiToDate(formMasterData.createdDate),
      //             created_by_name: window.localStorage.getItem('name'),
      //             created_by_id: window.localStorage.getItem('emp_id'),
      //             update_date: null,
      //             update_by_name: null,
      //             update_by_id: null,
      //             approved_date: null,
      //             approved_by_name: null,
      //             approved_by_id: null,
      //             cancel_date: null,
      //             cancel_by_name: null,
      //             cancel_by_id: null,
      //             approved_memo: null,
      //             printed_status: "N",
      //             printed_date: null,
      //             printed_by: null,
      //             cancel_memo: null,
      //             total_pay_per: parseCurrency(formMasterData.amountPay)
      //         };

      //         let additionalResponse = await Axios.post(`${process.env.REACT_APP_API_URL}/api/create-pay-h`, formData, {
      //             headers: { key: process.env.REACT_APP_ANALYTICS_KEY }
      //         });

      //         if (additionalResponse.data.status !== 'OK') {
      //             getAlert("FAILED", "ไม่สามารถบันทึกรายการที่เหลือได้");
      //             return;
      //         }

      //         let getPayIdResponse = await Axios.post(`${process.env.REACT_APP_API_URL}/api/get-by-pay-no`, {
      //             table: 'PAY_H',
      //             pay_no: incrementedPayNo
      //             comp_id: window.localStorage.getItem('company')
      //         }, {
      //             headers: { key: process.env.REACT_APP_ANALYTICS_KEY }
      //         });

      //         if (getPayIdResponse && getPayIdResponse.data.length > 0) {
      //             let detailPromises = formDetailList.map((item) => {
      //                 let payId = parseCurrency(getPayIdResponse.data[0].Pay_Id, 10);
      //                 let detailIndex = 1;

      //                 let formDetailData = {
      //                     pay_id: payId,
      //                     rec_dt_id: item.recDtId,
      //                     rec_id: item.recId,
      //                     line: detailIndex,
      //                     item_id: item.itemId,
      //                     item_code: item.itemCode,
      //                     item_name: item.itemName,
      //                     item_qty: parseCurrency(item.itemQty),
      //                     item_unit: item.itemUnit,
      //                     item_price_unit: parseCurrency(item.itemPriceUnit),
      //                     item_discount: parseCurrency(item.itemDiscount),
      //                     item_distype: item.itemDisType === '1' ? parseCurrency("1", 10) : parseCurrency("2", 10),
      //                     item_total: parseCurrency(item.itemTotal),
      //                     item_status: item.itemStatus,
      //                     wh_id: parseCurrency(item.whId, 10),
      //                     zone_id: parseCurrency("1", 10),
      //                     lt_id: parseCurrency("1", 10),
      //                     ds_seq: formatDateTime(new Date())
      //                 };

      //                 detailIndex++;

      //                 return Axios.post(`${process.env.REACT_APP_API_URL}/api/create-pay-d`, formDetailData, {
      //                     headers: { key: process.env.REACT_APP_ANALYTICS_KEY }
      //                 });
      //             });

      //             await Promise.all(detailPromises);
      //         }
      //     }
      // }

      callInitialize();
      getAlert(response.data.status, response.data.message);
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleCancel = async () => {
    try {
      // Flow ยกเลิกใหม่จากพี่แบงค์ ระบบต้อง Auto ยกเลิกใบลูก หรือ ที่เกี่ยวข้องกับการจ่ายเป็นงวดทั้งหมด
      // ยกเว้นสถานะที่มีการจ่ายไปแล้ว จะไม่ทำอะไร
      if (formMasterList[0].refDoc !== null) {
        // ใบลูก => ต้องค้นหาเพื่อนๆ และแม่
        const fromMaster = await getDataWithComp(
          "PAY_H",
          `AND Pay_Id = ${formMasterList[0].refDocID} AND Ref_DocID IS NULL`
        );
        const fromSubMaster = await getDataWithComp(
          "PAY_H",
          `AND Pay_Id <> ${formMasterList[0].payId} AND Ref_DocID = ${formMasterList[0].refDocID}`
        );

        // ตรวจสอบว่าพบข้อมูลจาก fromMaster หรือไม่
        if (fromMaster.length > 0 && fromMaster[0].Pay_Status === 1) {
          let formMasterData = {
            pay_no: fromMaster[0].Pay_No,
            pay_status: parseCurrency("13", 10),
            cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
            cancel_by_name: window.localStorage.getItem("name"),
            cancel_by_id: window.localStorage.getItem("emp_id"),
            comp_id: window.localStorage.getItem("company"),
          };
          await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/cancel-pay-h`,
            formMasterData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );

          // หยอด Item_Status = 0 ด้วย
          await handleCancelDetail(fromMaster[0]?.Pay_Id);
        }

        // ตรวจสอบว่าพบข้อมูลจาก fromSubMaster หรือไม่
        if (fromSubMaster.length > 0) {
          for (let i = 0; i < fromSubMaster.length; i++) {
            if (fromSubMaster[i].Pay_Status === 1) {
              let formSubMasterData = {
                pay_no: fromSubMaster[i].Pay_No,
                pay_status: parseCurrency("13", 10),
                cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
                cancel_by_name: window.localStorage.getItem("name"),
                cancel_by_id: window.localStorage.getItem("emp_id"),
                comp_id: window.localStorage.getItem("company"),
              };
              await Axios.post(
                `${process.env.REACT_APP_API_URL}/api/cancel-pay-h`,
                formSubMasterData,
                {
                  headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
                }
              );

              // หยอด Item_Status = 0 ด้วย
              await handleCancelDetail(fromSubMaster[i]?.Pay_Id);
            }
          }
        }
      } else {
        // ใบแม่ => ค้นหาแค่ลูกๆ
        const fromSubMaster = await getDataWithComp(
          "PAY_H",
          `AND Ref_DocID = ${formMasterList[0].payId}`
        );

        // ตรวจสอบว่าพบข้อมูลจาก fromSubMaster หรือไม่
        if (fromSubMaster.length > 0) {
          for (let i = 0; i < fromSubMaster.length; i++) {
            // เพิ่มดักเงื่อนไขว่า ต้องเป็นสถานะรอจ่ายเท่านั้น
            if (fromSubMaster[i].Pay_Status === 1) {
              let formSubMasterData = {
                pay_no: fromSubMaster[i].Pay_No,
                pay_status: parseCurrency("13", 10),
                cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
                cancel_by_name: window.localStorage.getItem("name"),
                cancel_by_id: window.localStorage.getItem("emp_id"),
                comp_id: window.localStorage.getItem("company"),
              };
              await Axios.post(
                `${process.env.REACT_APP_API_URL}/api/cancel-pay-h`,
                formSubMasterData,
                {
                  headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
                }
              );

              // หยอด Item_Status = 0 ด้วย
              await handleCancelDetail(fromSubMaster[i]?.Pay_Id);
            }
          }
        }
      }

      // นอกนั้นคือการยกเลิกใบที่ onRowSelect
      const formMasterData = {
        pay_no: maxPayNo,
        pay_status: parseCurrency("13", 10),
        cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
        cancel_by_name: window.localStorage.getItem("name"),
        cancel_by_id: window.localStorage.getItem("emp_id"),
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-pay-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // หยอด Item_Status = 0 ด้วย
      await handleCancelDetail(formMasterList[0].payId);

      callInitialize();
      getAlert(response.data.status, response.data.message);
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleCancelDetail = async (payId) => {
    await updateQty(
      "PAY_D",
      `Item_Status = '${parseCurrency("0", 10)}'`,
      `WHERE Pay_Id = ${payId}`
    );
  };

  // ฟังก์ชั่นเพิ่มค่า PayNo ด้วย index
  const incrementPayNoWithIndex = (payNo, index) => {
    const prefix = payNo.slice(0, 7); // รวมปีและเดือนใน prefix
    const numPart = parseCurrency(payNo.slice(7)) + index;
    return prefix + numPart.toString().padStart(4, "0");
  };

  // ฟังก์ชันสำหรับจัดการการเปลี่ยนแปลงใน formDetailList
  const handleChangeDetail = (index, field, value) => {
    const numericFields = ["itemQty", "itemPriceUnit", "itemDiscount"];

    // ✅ ตรวจเฉพาะฟิลด์ตัวเลขเท่านั้น
    if (numericFields.includes(field) && !/^\d*\.?\d*$/.test(value)) {
      return;
    }

    const updatedList = [...formDetailList];

    // ✅ เงื่อนไขเฉพาะ itemQty ในใบมัดจำ
    if (
      docRefType === "3" &&
      field === "itemQty" &&
      parseCurrency(value, 10) >
      parseCurrency(updatedList[index].itemOldQty, 10)
    ) {
      updatedList[index][field] = parseCurrency(
        updatedList[index].itemOldQty,
        10
      );
      setFormDetailList(updatedList);
      getAlert("FAILED", "ไม่สามารถรับสินค้าเกินกว่าสินค้าในใบมัดจำได้");
      return;
    }

    updatedList[index][field] = value;

    // ✅ คำนวณยอดรวมเมื่อเป็นฟิลด์เกี่ยวกับราคา/จำนวน
    const itemQty = parseCurrency(updatedList[index].itemQty) || 0;
    const itemPriceUnit = parseCurrency(updatedList[index].itemPriceUnit) || 0;
    const itemDiscount = parseCurrency(updatedList[index].itemDiscount) || 0;
    const itemDisType = String(updatedList[index].itemDisType);

    let itemTotal = itemQty * itemPriceUnit;
    if (itemDisType === "2") {
      itemTotal -= (itemDiscount / 100) * itemTotal;
    } else {
      itemTotal -= itemDiscount;
    }

    updatedList[index].itemTotal = itemTotal;
    setFormDetailList(updatedList);
  };

  const handleFocusMaster = (index, field) => {
    const updatedList = [...formMasterList];
    // กำหนดค่าเริ่มต้นถ้า field เป็น undefined
    const value = updatedList[index][field] || 0;
    updatedList[index][field] = parseCurrency(
      value.toString().replace(/,/g, "")
    );
    setFormMasterList(updatedList);
  };

  const handleBlurMaster = (index, field, value) => {
    const numericValue = parseCurrency(value.replace(/,/g, "")) || 0;
    const formattedValue = formatCurrency(numericValue);

    const updatedList = [...formMasterList];
    updatedList[index][field] = formattedValue;
    setFormMasterList(updatedList);
  };

  const handleFocusDetail = (index, field) => {
    const updatedList = [...formDetailList];
    // กำหนดค่าเริ่มต้นถ้า field เป็น undefined
    const value = updatedList[index][field] || 0;
    updatedList[index][field] = parseCurrency(
      value.toString().replace(/,/g, "")
    );
    setFormDetailList(updatedList);
  };

  const handleBlurDetail = (index, field, value) => {
    const numericValue = parseCurrency(value.replace(/,/g, "")) || 0;
    const formattedValue = formatCurrency(
      numericValue,
      field === "itemPriceUnit"
    );

    const updatedList = [...formDetailList];
    updatedList[index][field] = formattedValue;
    setFormDetailList(updatedList);
  };

  // ฟังก์ชันสำหรับจัดการการเปลี่ยนแปลงใน formMasterList (action สำหรับตาราง)
  const handleChangeMasterList = (index, field, value) => {
    // ตรวจสอบว่า field เป็น 'amountPay' และค่าที่กรอกเข้ามาเป็นตัวเลขหรือไม่
    if (field === "amountPay" && !/^\d*\.?\d*$/.test(value)) {
      // แจ้งเตือนหากไม่ใช่ตัวเลข
      // getAlert("FAILED", "กรุณากรอกเฉพาะตัวเลขเท่านั้น");
      return;
    }

    const updatedList = [...formMasterList];
    updatedList[index][field] = value;
    setFormMasterList(updatedList);
  };

  const handleChangeDateMasterList = (value, name, index) => {
    // ตรวจสอบว่า value เป็น moment object หรือไม่
    const newValue =
      value && value instanceof moment ? value.format("YYYY-MM-DD") : value;

    // อัปเดตค่าใน formMasterList
    const updatedList = [...formMasterList];
    updatedList[index][name] = formatDateOnChange(newValue);
    setFormMasterList(updatedList);
  };

  // ฟังก์ชันสำหรับจัดการการเปลี่ยนแปลงของเอกสารอ้างอิง
  const handleChangePayType = (value) => {
    const newPayMasterModel = [payMasterModel()];
    setFormMasterList(newPayMasterModel);
    setFormDetailList([]);
    // setSelectedDiscountValueType("2");
    setTotalPrice(0);
    setReceiptDiscount(0);
    setSubFinal(0);
    setGrandTotal(0);
    setIsVatChecked(true);
    setVatAmount(0);
    setARContactlist([]);
    setDocRefType(value);
  };

  // ฟังก์ชันสำหรับจัดการการเปลี่ยนแปลงของสถานะจ่าย
  const handlePaymentStatusChange = (status) => {
    // เก็บค่าของ formMasterList ที่มีอยู่เดิม
    const currentList = formMasterList[0]
      ? formMasterList[0]
      : payMasterModel();

    // เก็บค่า ap ข้อมูลไว้ก่อน
    const apData = {
      apID: currentList.apID,
      apCode: currentList.apCode,
      apName: currentList.apName,
      apAdd1: currentList.apAdd1,
      apAdd2: currentList.apAdd2,
      apAdd3: currentList.apAdd3,
      apProvince: currentList.apProvince,
      apZipcode: currentList.apZipcode,
      apTaxNo: currentList.apTaxNo,
    };

    if (status === "oneTime") {
      // ตั้งค่าให้กับรายการเดียว โดยเก็บค่าเดิมไว้ที่ตำแหน่งที่ 0
      setFormMasterList([
        {
          ...currentList,
          amountPay: formatCurrency(grandTotal),
          docRemark1: "",
          docRemark2: "",
          ...apData, // ตั้งค่า ap ข้อมูลกลับไป
        },
      ]);
      setInstallmentCount(1); // ย้ายการตั้งค่ามาหลังจากกำหนด formMasterList แล้ว
    } else {
      // สร้างรายการตามจำนวน installmentCount โดยไม่เคลียร์ datePay
      const newList = Array.from({ length: installmentCount }, (v, i) => {
        let amountPay = (grandTotal / installmentCount).toFixed(2);
        if (i === installmentCount - 1) {
          amountPay = (grandTotal - amountPay * (installmentCount - 1)).toFixed(
            2
          );
        }
        return {
          ...payMasterModel(),
          amountPay: formatCurrency(amountPay),
          docRemark1: "",
          docRemark2: "",
          ...apData, // ตั้งค่า ap ข้อมูลกลับไป
        };
      });
      // ตั้งค่าให้กับ formMasterList โดยเก็บค่าเดิมไว้ที่ตำแหน่งที่ 0 และแทนที่ค่าใหม่
      newList[0] = currentList;
      setFormMasterList(newList);
    }

    setPaymentStatus(status); // ย้ายการตั้งค่ามาหลังจากกำหนด formMasterList แล้ว
  };

  // ฟังก์ชันสำหรับจัดการการเปลี่ยนแปลงของจำนวนงวด
  const handleInstallmentCountChange = (value) => {
    if (!/^\d*$/.test(value) || value === "" || value === "0") return 1; // ตรวจสอบว่าเป็นตัวเลขเท่านั้น

    const count = parseCurrency(value, 10); // แปลงค่าจาก string เป็น number

    if (count > 100) {
      getAlert(
        "FAILED",
        "คุณไม่สามารถกำหนดจำนวนงวดเกิน 100 งวดได้ กรุณากรอกค่าใหม่อีกครั้ง"
      );
      return 1;
    }

    // เก็บค่าของ formMasterList ที่มีอยู่เดิม
    const currentList = formMasterList[0]
      ? formMasterList[0]
      : payMasterModel();

    // เก็บค่า ap ข้อมูลไว้ก่อน
    const apData = {
      docDueDate: currentList.docDueDate, // ถ้าเป็นการสร้างใบจ่ายด้วยใบรับสินค้า
      apID: currentList.apID,
      apCode: currentList.apCode,
      arID: currentList.arID,
      arCode: currentList.arCode,
      apName:
        parseCurrency(docRefType) === 3
          ? currentList.arName
          : currentList.apName,
      apAdd1: currentList.AP_Add1,
      apAdd2: currentList.AP_Add2,
      apAdd3: currentList.AP_Add3,
      apProvince: currentList.AP_Province,
      apZipcode: currentList.AP_Zipcode,
      apTaxNo: currentList.AP_TaxNo,
    };

    // สร้าง default model ที่ใช้เป็นค่าเริ่มต้น
    const defaultModel = payMasterModel();

    // คำนวณ amountPay สำหรับแต่ละงวด
    const installmentAmount = (grandTotal / count).toFixed(2);
    let newList = Array.from({ length: count }, (v, i) => {
      let amountPay = installmentAmount;
      if (i === count - 1) {
        amountPay = (grandTotal - installmentAmount * (count - 1)).toFixed(2);
      }
      return {
        ...defaultModel,
        datePay: i === 0 ? currentList.datePay : null, // datePay จะไม่เป็น null เฉพาะรายการแรก
        amountPay: formatCurrency(parseCurrency(amountPay)),
        docRemark1: "", // เคลียร์ค่าเฉพาะที่ต้องการ
        docRemark2: "", // เคลียร์ค่าเฉพาะที่ต้องการ
        ...apData, // ตั้งค่า ap ข้อมูลกลับไป
      };
    });

    setInstallmentCount(count); // ตั้งค่าจำนวนงวด
    setFormMasterList(newList); // อัปเดต formMasterList
  };

  const [showEditModal, setShowEditModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [newItemName, setNewItemName] = useState("");

  const handleCloseModal = () => {
    setShowEditModal(false);
    setEditingItem(null);
    setNewItemName("");
  };

  const handleOpenModal = (index, item) => {
    setEditingItem(index);
    setNewItemName(item.itemName || "");
    setShowEditModal(true);
  };

  const handleSaveChanges = () => {
    if (editingItem !== null) {
      handleChangeDetail(editingItem, "itemName", newItemName);
    }
    handleCloseModal();
  };

  // SET REC
  const [showRecModal, setShowRecModal] = useState(false);
  const handleRecShow = () => setShowRecModal(true);
  const handleRecClose = () => setShowRecModal(false);
  const onRowSelectRec = async (recSelected) => {
    try {
      const [getAllRecH, getAllItem] = await Promise.all([
        getDataWithComp("API_0301_REC_H", "ORDER BY Rec_No DESC"),
        getDataWithComp("API_0302_REC_D", "ORDER BY Line ASC"),
      ]);

      const recRawData = getAllRecH.find(
        (rec) => rec.Rec_No === recSelected[0].Rec_No
      );

      const unpaidRec = recSelected.find((rec) => rec.Doc_Status_Paid === 1);
      if (unpaidRec) {
        recSelected = [unpaidRec];

        const resultsPayD = await getData(
          "PAY_D",
          `Rec_Id = ${unpaidRec.Rec_ID}`
        );
        if (resultsPayD && resultsPayD.length > 0) {
          const resultsRecPay = await getData(
            "PAY_D",
            `Pay_Id = ${resultsPayD[0]?.Pay_Id} AND Item_Status = 1`
          );
          if (resultsRecPay && resultsRecPay.length > 0) {
            recSelected.length = 0;
            let outstandingBalance = grandTotal;

            resultsRecPay.forEach((result) => {
              let filteredRec = getAllRecH.find(
                (rec) =>
                  parseCurrency(rec.Rec_ID) === parseCurrency(result.Rec_Id)
              );
              if (filteredRec) {
                recSelected.push(filteredRec);

                const uniqueRecIds = new Set(
                  recSelected.map((rec) => rec.Rec_ID)
                );
                if (uniqueRecIds.size > 1) {
                  // getAlert("INFO", "ระบบดึงใบรับที่ถูกจ่ายร่วมมาให้โดยอัตโนมัติ");
                }

                if (filteredRec.Doc_Status_Paid === 2) {
                  setIsPayContinue(true);
                  outstandingBalance -= filteredRec.NetTotal;
                }
              }
            });
          }
        }
      }

      const recNoArray = Array.from(
        new Set(recSelected.map((rec) => rec.Rec_No))
      );

      const createNewRow = (index, itemSelected) => {
        const itemQty = parseCurrency(itemSelected.Item_Qty) || 0;
        const itemPriceUnit = parseCurrency(itemSelected.Item_Price_Unit) || 0;
        const itemDiscount = parseCurrency(itemSelected.Item_Discount) || 0;
        let itemTotal = itemQty * itemPriceUnit;

        if (itemSelected.Item_DisType === 2) {
          itemTotal -= (itemDiscount / 100) * itemTotal;
        } else {
          itemTotal -= itemDiscount;
        }

        return {
          ...payDetailModel(index + 1),
          recDtId: itemSelected.DT_Id,
          recId: itemSelected.Rec_ID,
          line: itemSelected.Line,
          itemId: itemSelected.Item_Id,
          recNo: itemSelected.Rec_No,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty: formatCurrency(itemQty),
          itemUnit: itemSelected.Item_Unit,
          itemPriceUnit: formatCurrency(itemPriceUnit),
          itemDiscount: formatCurrency(itemDiscount),
          itemDisType: String(itemSelected.Item_DisType),
          itemTotal,
          itemStatus: itemSelected.Item_Status,
          whId: itemSelected.WH_ID,
          whName: itemSelected.WH_Name,
          zoneId: itemSelected.Zone_ID,
          ltId: itemSelected.LT_ID,
          dsSeq: itemSelected.DS_SEQ,
        };
      };

      const fetchDetailsForRecNo = async (recNo) => {
        const filterItem = getAllItem.filter((item) => item.Rec_No === recNo);
        const fromViewRecH = getAllRecH.find((po) => po.Rec_No === recNo);

        if (!fromViewRecH)
          throw new Error(`ไม่พบ REC_H สำหรับ Rec_No: ${recNo}`);
        if (filterItem.length === 0)
          throw new Error(`ไม่พบ REC_D สำหรับ Rec_No: ${recNo}`);

        const newFormDetails = filterItem.map((item, index) =>
          createNewRow(index, item)
        );

        return { fromViewRecH, newFormDetails };
      };

      const results = await Promise.all(
        recNoArray.map((recNo) => fetchDetailsForRecNo(recNo))
      );
      const allDetails = results.flatMap((result) => result.newFormDetails);

      const [getViewPoH] = await Promise.all([
        getDataWithComp("API_0201_PO_H", ""),
      ]);
      const [getViewRecH] = await Promise.all([
        getDataWithComp("API_0301_REC_H", ""),
      ]);

      let receiptDiscount = 0;
      let receiptVatAmount = 0;

      const calculateDiscountAndVat = (rec, isUpdateMode = false) => {
        let related;
        if (docRefType === "1") {
          related = getViewRecH.find((r) => r.Ref_DocID === rec.Ref_DocID);
        } else {
          related = getViewPoH.find((r) => r.DocID === rec.Ref_DocID);
        }

        if (related) {
          const discountValue =
            related.Discount_Value_Type === 2
              ? (related.Discount_Value / 100) * rec.NetTotal
              : related.Discount_Value;

          if (isUpdateMode) {
            receiptDiscount = discountValue;
          } else if (docRefType === "1") {
            receiptDiscount = related.Discount_Cash;
          } else {
            receiptDiscount += discountValue;
          }

          if (related.IsVat === 1) {
            const vatAmount = (rec.NetTotal - discountValue) * 0.07;
            if (isUpdateMode) {
              receiptVatAmount = vatAmount;
            } else {
              receiptVatAmount += vatAmount;
            }
            setIsVatChecked(true);
          }

          setSelectedDiscountValueType(
            related.Discount_Value_Type === 2 ? "2" : "1"
          );
        }
      };

      recSelected.forEach((rec) => calculateDiscountAndVat(rec, mode === "U"));

      setFormDetailList(allDetails);

      const minRecDate = Math.min(
        ...recSelected.map((rec) => new Date(rec.Rec_Date).getTime())
      );

      if (mode !== "U") {
        const firstRec = results[0].fromViewRecH;
        setFormMasterList((prev) =>
          prev.map((item, i) =>
            i === 0
              ? {
                ...item,
                refDocID: firstRec.Rec_Id,
                refDoc: firstRec.Rec_No,
                discountValue: firstRec.Discount_Value,
                payDate: formatThaiDateUi(moment()),
                docDueDate: formatThaiDateUi(moment(minRecDate)),
                transportType: firstRec.Transport_Type,
                apID: firstRec.AP_ID,
                apCode: firstRec.AP_Code,
                apName: firstRec.AP_Name,
                apAdd1: firstRec.AP_Add1,
                apAdd2: firstRec.AP_Add2,
                apAdd3: firstRec.AP_Add3,
                apProvince: firstRec.AP_Province,
                apZipcode: firstRec.AP_Zipcode,
                apTaxNo: firstRec.AP_TaxNo,
                createdByName: localStorage.getItem("name"),
                createdDate: getCreateDateTime(),
                updateByName: firstRec.Update_By_Name,
                updateDate: firstRec.Update_Date,
              }
              : item
          )
        );

        const apId = firstRec.AP_ID;
        const apBankList = await getData(
          "Tb_Set_AP_Account",
          `ap_id = ${apId}`
        );

        if (apBankList.length > 0) {
          const mapped = apBankList.map((item) => ({
            id: item.id,
            bank_name: item.bank_name,
            bank_acc_no: item.bank_acc_no,
            bank_acc_name: item.bank_acc_name,
            bank_default: item.bank_default,
          }));

          setARContactlist(mapped);

          const defaultBank = apBankList.find(
            (bank) => bank.bank_default === "Y"
          );

          const bankData = defaultBank
            ? {
              bank_name: defaultBank.bank_name,
              bank_acc_no: defaultBank.bank_acc_no,
              bank_acc_name: defaultBank.bank_acc_name,
              bank_default: defaultBank.bank_default,
            }
            : {
              bank_name: "",
              bank_acc_no: "",
              bank_acc_name: "",
              bank_default: "N",
            };

          setFormMasterList((prev) =>
            prev.map((item, index) =>
              index === 0
                ? {
                  ...item,
                  ...bankData,
                }
                : item
            )
          );
        }

        const apFeedbackList = await getData("Tb_Set_AP", `ap_id = ${apId}`);

        if (apFeedbackList.length > 0) {
          const { AP_FB_Email, AP_FB_Telephone } = apFeedbackList[0];

          const FeedbackData = {
            fb_Email: AP_FB_Email || "",
            fb_Telephone: AP_FB_Telephone || "",
          };

          setFormMasterList((prev) =>
            prev.map((item, index) =>
              index === 0
                ? {
                  ...item,
                  ...FeedbackData,
                }
                : item
            )
          );
        }
      }

      setReceiptDiscount(receiptDiscount);
      setVatAmount(receiptVatAmount);
      handleRecClose();
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  const onConfirmRecSelection = async (recSelected) => {
    try {
      if (!recSelected[0]) {
        getAlert("FAILED", "ท่านยังไม่ได้เลือกใบรับสินค้า");
        return;
      }

      handleRecClose();

      // เคลียร์ค่าใน formMasterList และ formDetailList
      setFormMasterList([payMasterModel()]);
      setFormDetailList([]);
      setPaymentStatus("oneTime");
      setInstallmentCount(1);

      onRowSelectRec(recSelected);

      // แจ้งเตือนผู้ใช้ว่าการเลือกสำเร็จ
      getAlert("OK", "การเลือกใบรับสินค้าสำเร็จ");
    } catch (error) {
      console.error("Error in confirming receipt selection:", error);
      getAlert("FAILED", "เกิดข้อผิดพลาดในการเลือกใบรับสินค้า");
    }
  };

  // SET DEPOS
  const [showDeposModal, setShowDeposModal] = useState(false);
  const handleDeposShow = () => setShowDeposModal(true);
  const handleDeposClose = () => setShowDeposModal(false);
  const onRowSelectDepos = async (deposSelected) => {
    try {
      // เคลียร์ค่า
      setFormMasterList([payMasterModel()]);
      setFormDetailList([]);
      setPaymentStatus("oneTime");
      setInstallmentCount(1);

      // ดึงข้อมูล master
      const [findDeposMaster] = await Promise.all([
        getDataWithComp("DEPOS_H", ""),
      ]);
      const fromDeposDatabase = findDeposMaster.find(
        (depos) => depos.Doc_No === deposSelected.Doc_No
      );

      if (!fromDeposDatabase) {
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      // สร้างแถว detail
      const createNewRow = (index, itemSelected) => {
        const itemQty = parseCurrency(itemSelected.Item_Qty) || 0;
        const itemPriceUnit = parseCurrency(itemSelected.Item_Price_Unit) || 0;
        const itemDiscount = parseCurrency(itemSelected.Item_Discount) || 0;
        let itemTotal = itemQty * itemPriceUnit;

        if (itemSelected.Item_DisType === 2) {
          itemTotal -= (itemDiscount / 100) * itemTotal;
        } else {
          itemTotal -= itemDiscount;
        }

        return {
          ...payDetailModel(index + 1),
          docId: itemSelected.Doc_ID,
          line: itemSelected.Line,
          itemId: itemSelected.Item_Id,
          recNo: itemSelected.Rec_No,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty,
          itemOldQty: formatCurrency(itemQty),
          itemUnit: itemSelected.Item_Unit,
          itemPriceUnit: formatCurrency(itemPriceUnit),
          itemDiscount: formatCurrency(itemDiscount),
          itemDisType: String(itemSelected.Item_DisType),
          itemTotal,
          itemStatus: itemSelected.Item_Status,
          whId: itemSelected.WH_ID,
          whName: itemSelected.WH_Name,
          zoneId: itemSelected.Zone_ID,
          ltId: itemSelected.LT_ID,
          dsSeq: itemSelected.DS_SEQ,
        };
      };

      const fromDeposDetail = await getByDocId(
        "DEPOS_D",
        fromDeposDatabase.Doc_Id,
        `AND Item_Status = 1 ORDER BY Line ASC`
      );

      if (fromDeposDetail.length > 0) {
        const newFormDetails = fromDeposDetail.map((item, index) =>
          createNewRow(index, item)
        );
        setFormDetailList(newFormDetails);

        if (mode !== "U") {
          setFormMasterList((prevState) =>
            prevState.map((item) => ({
              ...item,
              payNo: maxPayNo,
              payDate: formatThaiDateUi(moment()),
              docDueDate: formatThaiDateUi(moment()),
              refDoc: deposSelected.Doc_No,
              refDocDate: formatThaiDateUi(deposSelected.Doc_Date || null),
              transportType: deposSelected.Transport_Type,
              arID: deposSelected.AR_ID,
              arCode: deposSelected.AR_Code,
              apName: deposSelected.AR_Name,
              discountValue: deposSelected.Discount_Value,
              discountValueType: deposSelected.Discount_Value_Type,
              isVat: deposSelected.IsVat,
              apAdd1: deposSelected.AR_Add1,
              apAdd2: deposSelected.AR_Add2,
              apAdd3: deposSelected.AR_Add3,
              apProvince: deposSelected.AR_Province,
              apZipcode: deposSelected.AR_Zipcode,
              apTaxNo: deposSelected.AR_TaxNo,
              printedStatus: deposSelected.Printed_Status,
            }))
          );

          // ✅ เพิ่ม: โหลดบัญชีธนาคารของ AR จาก AR_ID
          const arBankList = await getData(
            "Tb_Set_AR_Account",
            `ar_id = ${deposSelected.AR_ID}`
          );

          if (arBankList.length > 0) {
            const mapped = arBankList.map((item) => ({
              id: item.id,
              bank_name: item.bank_name,
              bank_acc_no: item.bank_acc_no,
              bank_acc_name: item.bank_acc_name,
              bank_default: item.bank_default,
            }));
            setARContactlist(mapped);

            const defaultBank = arBankList.find(
              (bank) => bank.bank_default === "Y"
            );

            const bankData = defaultBank
              ? {
                bank_name: defaultBank.bank_name,
                bank_acc_no: defaultBank.bank_acc_no,
                bank_acc_name: defaultBank.bank_acc_name,
                bank_default: defaultBank.bank_default,
              }
              : {
                bank_name: "",
                bank_acc_no: "",
                bank_acc_name: "",
                bank_default: "N",
              };

            // อัปเดต bank ลง formMasterList
            setFormMasterList((prev) =>
              prev.map((item, i) =>
                i === 0
                  ? {
                    ...item,
                    ...bankData,
                  }
                  : item
              )
            );
          }
        }
      }

      handleDeposClose(); // ปิด modal
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  // SET AP
  const [showApModal, setShowApModal] = useState(false);
  const handleApShow = () => setShowApModal(true);
  const handleApClose = () => setShowApModal(false);
  const onRowSelectAp = async (apSelected) => {
    try {
      // clear Bank List
      setARContactlist([]);
      // เก็บค่าของ formMasterList ที่มีอยู่เดิม
      const currentList = formMasterList[0]
        ? formMasterList[0]
        : payMasterModel();

      // เก็บค่า ap ข้อมูลไว้ก่อน
      const apData = {
        apID: apSelected.AP_Id,
        apCode: apSelected.AP_Code,
        apName: apSelected.AP_Name,
        apAdd1: apSelected.AP_Add1,
        apAdd2: apSelected.AP_Add2,
        apAdd3: apSelected.AP_Add3,
        apProvince: apSelected.AP_Province,
        apZipcode: apSelected.AP_Zipcode,
        apTaxNo: apSelected.AP_TaxNo,
        fb_Email: apSelected.AP_FB_Email,
        fb_Telephone: apSelected.AP_FB_Telephone,
      };

      // 🔍 ดึงข้อมูลบัญชีธนาคารตาม ap_id
      const apBankList = await getData(
        "Tb_Set_AP_Account",
        `ap_id = ${apSelected.AP_Id}`
      );

      if (apBankList.length > 0) {
        const mapped = apBankList.map((item) => ({
          id: item.id,
          bank_name: item.bank_name,
          bank_acc_no: item.bank_acc_no,
          bank_acc_name: item.bank_acc_name,
          bank_default: item.bank_default,
        }));

        setARContactlist(mapped);
      }

      // ✅ เลือกบัญชี default (bank_default === 'Y') ถ้ามี
      const defaultBank = apBankList.find((bank) => bank.bank_default === "Y");

      const bankData = defaultBank
        ? {
          bank_name: defaultBank.bank_name,
          bank_acc_no: defaultBank.bank_acc_no,
          bank_acc_name: defaultBank.bank_acc_name,
          bank_default: defaultBank.bank_default,
        }
        : {
          bank_name: "",
          bank_acc_no: "",
          bank_acc_name: "",
          bank_default: "N",
        };

      // ตั้งค่าให้กับรายการเดียว โดยเก็บค่าเดิมไว้ที่ตำแหน่งที่ 0
      setFormMasterList([
        {
          ...currentList,
          ...apData,
          ...bankData, // เพิ่มข้อมูลบัญชีธนาคาร
        },
      ]);

      handleApClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  // SET ITEM
  const [showItemModal, setShowItemModal] = useState(false);
  const handleItemShow = () => setShowItemModal(true);
  const handleItemClose = () => setShowItemModal(false);
  const onRowSelectItem = (itemsSelected) => {
    try {
      // ใช้ Set เพื่อกรอง Item_Id ที่ซ้ำกัน
      const uniqueItems = Array.from(
        new Set(itemsSelected.map((item) => item.Item_Id))
      ).map((id) => {
        return itemsSelected.find((item) => item.Item_Id === id);
      });

      // อัปเดตรายการโดยคงค่าของสินค้าที่เคยมีอยู่
      const updatedFormDetailList = uniqueItems.map((itemSelected) => {
        // ค้นหาว่ามีสินค้าอยู่ใน formDetailList เดิมหรือไม่
        const existingItem = formDetailList.find(
          (item) => item.itemId === itemSelected.Item_Id
        );

        return {
          line: existingItem?.line || null,
          itemId: itemSelected.Item_Id,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty: existingItem ? existingItem.itemQty : formatCurrency(0), // ใช้ค่าที่มีอยู่เดิม
          itemUnit: existingItem
            ? existingItem.itemUnit
            : itemSelected.Item_Unit_ST,
          itemPriceUnit: existingItem
            ? existingItem.itemPriceUnit
            : formatCurrency(itemSelected.Item_Cost || 0),
          itemDiscount: existingItem
            ? existingItem.itemDiscount
            : formatCurrency(0),
          itemDisType: existingItem ? existingItem.itemDisType : "1",
          itemTotal: existingItem ? existingItem.itemTotal : 0,
          itemStatus: itemSelected.Item_Status,
          whId: existingItem ? existingItem.whId : null,
          whName: existingItem ? existingItem.whName : itemSelected.WH_Name,
          zoneId: existingItem ? existingItem.zoneId : null,
          ltId: existingItem ? existingItem.ltId : null,
          dsSeq: existingItem ? existingItem.dsSeq : null,
        };
      });

      // อัปเดต formDetailList ด้วยข้อมูลที่กรองแล้ว
      setFormDetailList(updatedFormDetailList);
      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error);
    }
  };
  const onRowSelectItem02 = async (selectedItems) => {
    try {
      const existingItemIds = formDetailList
        .filter((item) => item.itemId !== null)
        .map((item) => item.itemId);

      const itemsToAdd = selectedItems.filter(
        (item) => !existingItemIds.includes(item.Item_Id)
      );

      const newItems = await Promise.all(
        itemsToAdd.map(async (itemSelected) => {
          let itemOnHand = 0;
          const response = await getDataWithComp(
            "API_1101_WH_ITEM_ONHAND",
            `AND WH_Id = ${parseCurrency(whid)} AND Item_Id = ${itemSelected.Item_Id
            }`
          );

          if (response && response.length > 0) {
            itemOnHand = parseCurrency(response[0].Item_Onhand);
          }

          return {
            line: null,
            itemId: itemSelected.Item_Id,
            itemCode: itemSelected.Item_Code,
            itemName: itemSelected.Item_Name,
            itemQty: formatCurrency(0),
            itemUnit: itemSelected.Item_Unit_ST,
            itemPriceUnit: formatCurrency(itemSelected.Item_Price || 0),
            itemDiscount: formatCurrency(0),
            itemDisType: "1",
            itemTotal: 0,
            itemStatus: itemSelected.Item_Status,
            whId: whid,
            whName: itemSelected.WH_Name,
            zoneId: null,
            ltId: null,
            dsSeq: null,
            itemOnHand: itemOnHand,
          };
        })
      );

      const emptyItem = {
        line: null,
        itemId: null,
        itemCode: null,
        itemName: null,
        itemQty: formatCurrency(0),
        itemUnit: "",
        itemPriceUnit: formatCurrency(0),
        itemDiscount: formatCurrency(0),
        itemDisType: "1",
        itemTotal: 0,
        itemStatus: "Y",
        whId: whid,
        whName: "",
        zoneId: null,
        ltId: null,
        dsSeq: null,
      };

      setFormDetailList((prev) => [...prev, ...newItems, emptyItem]);
      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error.message || "เกิดข้อผิดพลาด");
    }
  };

  const handleRemoveRow = (index) => {
    const newList = formDetailList.filter((_, i) => i !== index);
    setFormDetailList(newList);
  };
  const handleVatChange = () => {
    setIsVatChecked((prev) => !prev);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  // SET PO
  const [showPoModal, setShowPoModal] = useState(false);
  const handlePoShow = () => setShowPoModal(true);
  const handlePoClose = () => setShowPoModal(false);
  const [selectedPoList, setSelectedPoList] = useState([]);
  const onRowSelectPo = async (poSelected) => {
    try {
      if (!poSelected || !poSelected[0]?.Doc_No) {
        getAlert("FAILED", "ไม่มีข้อมูลใบสั่งซื้อที่เลือก");
        return;
      }

      setFormMasterList([]);
      setFormDetailList([]);

      const getAllPoH = await getDataWithComp(
        "API_0201_PO_H",
        "ORDER BY Doc_No DESC"
      );
      const fromViewPoH = getAllPoH.find(
        (po) => po.Doc_No === poSelected[0]?.Doc_No
      );

      const fromViewAp = apDataList.find(
        (ap) => ap.AP_Id === poSelected[0]?.AP_ID
      );
      if (!fromViewPoH || !fromViewAp) {
        console.debug("fromViewPoH:", fromViewPoH, "fromViewAp:", fromViewAp);
        throw new Error("ไม่พบข้อมูลใบสั่งซื้อ หรือข้อมูลผู้ขาย");
      }

      const getAllItem = await getDataWithComp(
        "API_0202_PO_D",
        "AND Item_Status = 1 ORDER BY Line ASC"
      );
      const filterItem = getAllItem.filter(
        (item) => item.Doc_No === poSelected[0]?.Doc_No
      );

      if (filterItem.length === 0) {
        getAlert(
          "FAILED",
          `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${poSelected[0]?.Doc_No}`
        );
        return;
      }

      const getPoH = await getByDocId("PO_H", filterItem[0]?.Doc_ID, ``);

      const createNewRow = (index, itemSelected) => {
        const itemQty = parseFloat(itemSelected?.Item_Qty) || 0;
        const itemPriceUnit = parseFloat(itemSelected?.Item_Price_Unit) || 0;
        const itemDiscount = parseFloat(itemSelected?.Item_Discount) || 0;
        let itemTotal = itemQty * itemPriceUnit;

        if (itemSelected?.Item_DisType === 2) {
          itemTotal -= (itemDiscount / 100) * itemTotal;
        } else {
          itemTotal -= itemDiscount;
        }

        return {
          ...recDetailModel(index + 1),
          line: itemSelected?.Line ?? "",
          itemId: itemSelected?.Item_Id ?? "",
          itemCode: itemSelected?.Item_Code ?? "",
          itemName: itemSelected?.Item_Name ?? "",
          itemQty: formatCurrency(itemQty),
          itemUnit: itemSelected?.Item_Unit ?? "",
          itemPriceUnit: formatCurrency(itemPriceUnit),
          itemDiscount,
          itemDisType: String(itemSelected?.Item_DisType ?? ""),
          itemTotal,
          itemGroup: itemSelected?.Item_Group ?? "",
          itemStatus: itemSelected?.Item_Status ?? "",
          whId: 13,
          zoneId: itemSelected?.Zone_ID ?? "",
          ltId: itemSelected?.LT_ID ?? "",
          dsSeq: itemSelected?.DS_SEQ ?? "",
        };
      };

      const newFormDetails = filterItem.map((item, index) =>
        createNewRow(index, item)
      );
      setFormDetailList(newFormDetails);

      const totalPrice = newFormDetails.reduce(
        (acc, item) => acc + (item.itemTotal || 0),
        0
      );

      let receiptDiscount = 0;
      let receiptVatAmount = 0;

      const calculateDiscountAndVat = (poH) => {
        if (poH) {
          const discountValue =
            poH.Discount_Value_Type === 2
              ? (poH.Discount_Value / 100) * totalPrice
              : poH.Discount_Value;
          receiptDiscount += discountValue;

          if (poH.IsVat === 1) {
            const vatAmount = (totalPrice - discountValue) * 0.07;
            receiptVatAmount = vatAmount;
            setIsVatChecked(true);
          }
        }
      };

      calculateDiscountAndVat(fromViewPoH);

      // ✅ โหลดข้อมูลธนาคารของ AP
      const apBankList = await getData(
        "Tb_Set_AP_Account",
        `ap_id = ${fromViewPoH?.AP_ID}`
      );

      if (apBankList.length > 0) {
        const mapped = apBankList.map((item) => ({
          id: item.id,
          bank_name: item.bank_name,
          bank_acc_no: item.bank_acc_no,
          bank_acc_name: item.bank_acc_name,
          bank_default: item.bank_default,
        }));
        setARContactlist(mapped);

        const defaultBank = apBankList.find(
          (bank) => bank.bank_default === "Y"
        );

        const bankData = defaultBank
          ? {
            bank_name: defaultBank.bank_name,
            bank_acc_no: defaultBank.bank_acc_no,
            bank_acc_name: defaultBank.bank_acc_name,
            bank_default: defaultBank.bank_default,
          }
          : {
            bank_name: "",
            bank_acc_no: "",
            bank_acc_name: "",
            bank_default: "N",
          };

        // ตั้งค่า Master List พร้อม bank
        setFormMasterList([
          {
            ...payMasterModel(),
            refDocID: fromViewPoH?.Doc_ID ?? "",
            refDoc: poSelected?.Doc_No ?? "",
            refDocDate: formatThaiDateUi(poSelected?.Doc_Date ?? ""),
            docDate: formatThaiDateUi(moment()),
            docDueDate: formatThaiDateUi(moment()),
            docRemark1: fromViewPoH?.Doc_Remark1 ?? "",
            docRemark2: fromViewPoH?.Doc_Remark2 ?? "",
            docType: fromViewPoH?.Doc_Type ?? "",
            docFor: fromViewPoH?.Doc_For ?? "",
            transportType: fromViewPoH?.Transport_Type ?? "",
            discountValue: fromViewPoH?.Discount_Value ?? 0,
            creditTerm: getPoH[0]?.CreditTerm ?? "",
            apID: fromViewPoH?.AP_ID ?? "",
            apCode: fromViewAp?.AP_Code ?? "",
            apName: fromViewAp?.AP_Name ?? "",
            apAdd1: fromViewAp?.AP_Add1 ?? "",
            apAdd2: fromViewAp?.AP_Add2 ?? "",
            apAdd3: fromViewAp?.AP_Add3 ?? "",
            apProvince: fromViewAp?.AP_Province ?? "",
            apZipcode: fromViewAp?.AP_Zipcode ?? "",
            apTaxNo: fromViewAp?.AP_TaxNo ?? "",
            createdByName: window.localStorage.getItem("name") ?? "",
            createdDate: getCreateDateTime(),
            updateDate: fromViewPoH?.Update_Date ?? "",
            updateByName: fromViewPoH?.Update_By_Name ?? "",
            amountPay: totalPrice - receiptDiscount + receiptVatAmount,
            ...bankData, // ✅ เพิ่มข้อมูลบัญชีธนาคาร
          },
        ]);
      }

      const apFeedbackList = await getData(
        "Tb_Set_AP",
        `ap_id = ${fromViewPoH?.AP_ID}`
      );

      if (apFeedbackList.length > 0) {
        const { AP_FB_Email, AP_FB_Telephone } = apFeedbackList[0];

        const FeedbackData = {
          fb_Email: AP_FB_Email || "",
          fb_Telephone: AP_FB_Telephone || "",
        };

        setFormMasterList((prev) =>
          prev.map((item, index) =>
            index === 0
              ? {
                ...item,
                ...FeedbackData,
              }
              : item
          )
        );
      }

      setReceiptDiscount(receiptDiscount);
      setVatAmount(receiptVatAmount);

      setIsVatChecked(fromViewPoH.IsVat === 1);
      handlePoClose();
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  useEffect(() => {
    const totalBeforeDiscount = formDetailList.reduce(
      (acc, item) => acc + (parseCurrency(item.itemTotal) || 0),
      0
    );

    // ดึงค่า discount จาก state
    const discount = receiptDiscount || 0; // ใช้ค่าล่าสุดของส่วนลด
    const total = totalBeforeDiscount - discount; // หักส่วนลดจาก total

    // ตรวจสอบชนิดของ amountPay และแปลงให้เหมาะสม
    let amountPay = formMasterList[0]?.amountPay;
    if (typeof amountPay === "string") {
      amountPay = parseCurrency(amountPay.replace(/,/g, "")) || 0;
    } else if (typeof amountPay === "number") {
      amountPay = amountPay || 0;
    } else {
      amountPay = 0;
    }

    if (parseCurrency(docRefType) === 1 && mode === "U") {
      setTotalPrice(totalBeforeDiscount);
      const vatAmount = total * 0.07;
      setVatAmount(vatAmount);
    } else {
      setTotalPrice(totalBeforeDiscount);

      // คำนวณ VAT จาก total ที่หักส่วนลดแล้ว
      const vatAmount = total * 0.07;
      setVatAmount(vatAmount);
    }
  }, [formDetailList, receiptDiscount]); // เพิ่ม receiptDiscount ใน dependency

  // การคำนวณส่วนลด (receiptDiscount)
  useEffect(() => {
    // let discountValue = parseCurrency(formMasterList.discountValue || 0);
    // let receiptDiscount = 0;
    // if (selectedDiscountValueType === '2') { // เปอร์เซ็นต์
    //     receiptDiscount = (totalPrice / 100) * discountValue;
    // } else if (selectedDiscountValueType === '1') { // จำนวนเงิน
    //     receiptDiscount = discountValue;
    // }
    // setReceiptDiscount(receiptDiscount);
  }, [totalPrice, formMasterList.discountValue, selectedDiscountValueType]);

  // การคำนวณยอดหลังหักส่วนลด (subFinal) (ไม่ได้ใช้)
  useEffect(() => {
    const subFinal = totalPrice - receiptDiscount;
    setSubFinal(subFinal);
  }, [totalPrice, receiptDiscount]);

  // การคำนวณ VAT (vatAmount)
  useEffect(() => {
    if (docRefType === "2") {
      const vat = isVatChecked ? subFinal * 0.07 : 0;
      setVatAmount(parseCurrency(vat.toFixed(2)));
    }
  }, [subFinal, isVatChecked]);

  // การคำนวณยอดรวมทั้งสิ้น (grandTotal)
  useEffect(() => {
    const calculatedGrandTotal = subFinal + vatAmount - totalWT;
    const calculatedFinalTotal = calculatedGrandTotal - disTotal;

    console.debug("calculatedGrandTotal", parseCurrency(calculatedGrandTotal));
    console.debug("calculatedFinalTotal", parseCurrency(calculatedFinalTotal));

    setGrandTotal(parseCurrency(calculatedGrandTotal));
    setFinalTotal(parseCurrency(calculatedFinalTotal));

    // Default ตามรวมทั้งสิ้น
    if (
      (parseCurrency(docRefType) === 1 && mode !== "U") ||
      (parseCurrency(docRefType) === 2 && formMasterList[0]?.payStatus === 1) ||
      (parseCurrency(docRefType) === 3 && mode !== "U")
    ) {
      const formattedValue = formatCurrency(calculatedFinalTotal);
      setFormMasterList((prevList) => {
        const updatedList = [...prevList];
        if (updatedList.length > 0) {
          updatedList[0].amountPay = formattedValue;
        }
        return updatedList;
      });
      // setOutstandingBalance(calculatedGrandTotal);
    }
  }, [subFinal, vatAmount, totalWT, disTotal]);

  // การคำนวณยอดรวมค้างจ่าย (OutstandingBalance)
  useEffect(() => {
    console.debug("formMasterList setOutstandingBalance", formMasterList);
    if (formMasterList[0]?.payStatus === 1) {
      setOutstandingBalance(FinalTotal);
    } else {
      setOutstandingBalance(0.0);
    }
  }, [grandTotal, outstandingBalance, FinalTotal]);

  useEffect(() => {
    // หาผลรวมของ amountPay ทั้งหมด
    let totalPaid = formMasterList.reduce((sum, formMaster) => {
      return sum + (parseCurrency(formMaster.amountPay) || 0);
    }, 0);

    // คำนวณยอดคงค้าง (Outstanding Balance)
    let totalOutstanding = parseCurrency(FinalTotal) - totalPaid;

    // ป้องกันค่าติดลบที่ไม่ควรมี (-0.00) โดยให้เป็น 0 แทน
    if (Math.abs(totalOutstanding) < 0.01) {
      totalOutstanding = 0;
    }
    // console.debug("totalOutstanding",totalOutstanding,"totalPaid",totalPaid,"FinalTotal",FinalTotal)

    // setOutstandingBalance(totalOutstanding);
  }, [formMasterList, grandTotal, totalWT, disTotal]);

  const [showModalDatePicker, setShowModalDatePicker] = useState(false);
  const [selectedDateIndex, setSelectedDateIndex] = useState(null);

  const openModalDatePicker = (index) => {
    setSelectedDateIndex(index);
    setShowModalDatePicker(true);
  };

  const closeModalDatePicker = () => setShowModalDatePicker(false);

  const handlereceiptDiscountChange = (value) => {
    // อนุญาตให้เป็นค่าว่าง
    if (value === "") {
      setReceiptDiscount("");
      return;
    }

    // ตรวจสอบว่าเป็นตัวเลขที่ถูกต้อง (อนุญาตให้มีจุดทศนิยม)
    if (/^\d*\.?\d*$/.test(value)) {
      setReceiptDiscount(value); // เก็บค่าเป็น string ก่อน
    }
  };

  const [showWTModal, setShowWTModal] = useState(false);
  const handleWTClose = () => setShowWTModal(false);
  const CalculationTotalWT = (event) => {
    const value = event.target.value.replace(/,/g, "");
    if (/^\d*\.?\d*$/.test(value)) {
      const numericValue = parseFloat(value) || 0;
      setTotalWT(numericValue);
      setInputValueTotalWT(value);
    }
  };

  const handleBlurTotalWT = () => {
    const numericValue =
      parseCurrency(inputValueTotalWT.replace(/,/g, "")) || 0;
    setTotalWT(numericValue);
    setInputValueTotalWT(
      numericValue.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    ); // ใส่ , คั่นหลักพัน
  };

  const handleFocusTotalWT = () => {
    setInputValueTotalWT(String(totalWT).replace(/,/g, ""));
  };

  const setdetailsTotalWT = () => {
    if (taxData.length === 0) {
      setTaxData([
        {
          id: 1,
          type: 5,
          percent: 3.0,
          date: currentDate,
          amount: 0.0,
          tax: 0.0,
          remark: "",
        },
        {
          id: 2,
          type: 6,
          percent: 3.0,
          date: currentDate,
          amount: 0.0,
          tax: 0.0,
          remark: "",
        },
      ]);
    }
    setShowWTModal(true);
  };

  const CalculationTotalDis = (event) => {
    const value = event.target.value.replace(/,/g, "");
    if (/^\d*\.?\d*$/.test(value)) {
      const numericValue = parseFloat(value) || 0;
      setDisTotal(numericValue);
      setInputValuedisTotal(value);
    }
  };

  const handleBlurTotalDis = () => {
    const numericValue = parseFloat(inputValuedisTotal.replace(/,/g, "")) || 0;
    setDisTotal(numericValue);
    setInputValuedisTotal(
      numericValue.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    ); // ใส่ , คั่นหลักพัน
  };

  const handleFocusTotalDis = () => {
    setInputValuedisTotal(String(disTotal).replace(/,/g, ""));
  };

  const getOutstandingColor = () => {
    if (outstandingBalance < 0) return "red"; // ค้างชำระ (จ่ายไม่ครบ) → สีแดง
    if (outstandingBalance > 0) return "green"; // จ่ายเกิน → สีเขียว
    return "black"; // พอดี → สีดำ
  };

  // ฟังก์ชันแสดงผลเครื่องหมาย + หรือ - ตามค่า
  const formatOutstanding = (amount) => {
    if (amount > 0) return `${formatCurrency(amount)}`; // ถ้าจ่ายเกินใส่เครื่องหมาย +
    if (amount < 0) return `${formatCurrency(amount)}`; // ถ้าจ่ายไม่ครบ แสดงค่าปกติ (ติดลบ)
    return formatCurrency(amount); // ถ้าพอดี ให้แสดง 0.00 ปกติ
  };

  const [apBankList, setARContactlist] = useState([]);
  console.debug("apBankList", apBankList);
  const bankOptions = [
    ...(formMasterList[0]?.bank_name &&
      !apBankList.some(
        (b) =>
          b.bank_name === formMasterList[0].bank_name &&
          b.bank_acc_no === formMasterList[0].bank_acc_no &&
          b.bank_acc_name === formMasterList[0].bank_acc_name
      )
      ? [
        {
          label: [
            formMasterList[0].bank_name,
            formMasterList[0].bank_acc_no,
            formMasterList[0].bank_acc_name,
          ]
            .filter(Boolean)
            .join(" | "),
          value: -1, // temporary value
          bankName: formMasterList[0].bank_name,
          bankAccNo: formMasterList[0].bank_acc_no,
          bankAccName: formMasterList[0].bank_acc_name,
        },
      ]
      : []),

    ...apBankList.map((bank, index) => ({
      label: [
        bank.bank_name,
        bank.bank_acc_no,
        bank.bank_acc_name,
        bank.bank_default === "Y" ? "บัญชีหลัก" : null,
      ]
        .filter(Boolean)
        .join(" | "),
      value: index, // หรือใช้ bank_id ถ้ามี
      bankName: bank.bank_name,
      bankAccNo: bank.bank_acc_no,
      bankAccName: bank.bank_acc_name,
      bankDefault: bank.bank_default,
    })),
  ];

  const PAYMENT_METHODS = {
    transfer: "โอนเงิน",
    cash: "เงินสด",
    cheque: "เช็ค",
  };

  const [paymentType, setPaymentType] = useState({
    transfer: true,
  });

  const GROUP_A = ["transfer", "cash", "cheque"];
  const isGroupASelected =
    paymentType && GROUP_A.some((method) => paymentType[method]);

  const togglePaymentMethod = (method) => {
    setPaymentType((prev) => ({
      ...prev,
      [method]: !prev[method],
    }));
  };

  const [chequeBank, setChequeBank] = useState("");
  const [chequeNo, setChequeNo] = useState("");
  const [chequeDate, setChequeDate] = useState("");
  const [transferDate, setTransferDate] = useState("");

  const getPayTransType = () => {
    if (paymentType.cash) return 0;
    if (paymentType.transfer) return 1;
    if (paymentType.cheque) return 2;
    return 0;
  };
  console.debug("getPayTransType", getPayTransType());

  return (
    <>
      <Breadcrumbs
        page={mode === "U" ? maxPayNo : displayPayNo}
        isShowStatus={mode === "U"}
        statusName={statusName}
        statusColour={statusColour}
        items={[
          { name: "จัดซื้อสินค้า", url: "/purchase" },
          { name: name, url: "/payment-voucher" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
        onHandleClick={() =>
          getReport(
            getPayTransType() === 2 ? "PAY_CHEQUE" : "PAY_CASH",
            formMasterList[0]?.payNo
          )
        }
      />
      <div
        className="hidden-scrollbar"
        style={{ maxHeight: "auto", overflowY: "auto" }}
      >
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>วันที่เอกสาร</label>
              <Datetime
                className="input-spacing-input-date"
                name="payDate"
                value={formMasterList[0]?.payDate || null}
                onChange={(date) =>
                  handleChangeDateMasterList(date, "payDate", 0)
                }
                dateFormat="DD-MM-YYYY"
                timeFormat={false}
                inputProps={{ readOnly: true, disabled: mode === "U" }}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>ผู้ขาย</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="apCode"
                  value={
                    (formMasterList[0]?.apCode || "") +
                    " " +
                    (formMasterList[0]?.apName || "")
                  }
                  onChange={handleChangeMasterList}
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleApShow}
                  disabled={
                    docRefType === "1" || docRefType === "3" || mode === "U"
                      ? true
                      : false
                  }
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </div>
            <ApModal
              showApModal={showApModal}
              handleApClose={handleApClose}
              apDataList={apDataList}
              onRowSelectAp={onRowSelectAp}
            />
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdDate"
                value={formMasterList[0]?.createdDate}
                // onChange={handleChangeMasterList}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label className="">เอกสารอ้างอิง</label>
              <select
                name="payType"
                value={formMasterList[0]?.docRefType}
                className="form-select form-control input-spacing"
                onChange={(e) => handleChangePayType(e.target.value)}
                disabled={mode === "U"}
              >
                <option value="1">จ่ายตามใบรับสินค้า</option>
                <option value="2">จ่ายเฉพาะรายการ</option>
                <option value="3">จ่ายตามใบสั่งซื้อ</option>
                {/* <option value="4" disabled>
                  จ่ายตามใบแจ้งซ่อม
                </option> */}
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>ที่อยู่</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="apAdd1"
                value={formMasterList[0]?.apAdd1 || ""}
                onChange={handleChangeMasterList}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdByName"
                value={formMasterList[0]?.createdByName || ""}
                onChange={handleChangeMasterList}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>อ้างอิงเอกสาร</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="refDoc"
                  value={formMasterList[0]?.refDoc || ""}
                  onChange={handleChangeMasterList}
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleRecShow}
                  hidden={docRefType === "1" ? false : true}
                  disabled={mode === "U"}
                >
                  <i className="fas fa-search"></i>
                </button>
                <button
                  className="btn btn-outline-secondary"
                  onClick={handlePoShow}
                  hidden={docRefType === "3" ? false : true}
                  disabled={mode === "U"}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
              <RecModal
                showRecModal={showRecModal}
                handleRecClose={handleRecClose}
                recDataList={recDataList}
                onConfirmRecSelection={onConfirmRecSelection}
              />
              <DeposModal
                showDeposModal={showDeposModal}
                handleDeposClose={handleDeposClose}
                deposDataList={deposDataList}
                onRowSelectDepos={onRowSelectDepos}
              />
              <PoModal
                showPoModal={showPoModal}
                handlePoClose={handlePoClose}
                poDataList={poDataList}
                onRowSelectPo={(selectedPoList) =>
                  onRowSelectPo(selectedPoList)
                }
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={
                  (formMasterList[0]?.apAdd2 || "") +
                  " " +
                  (formMasterList[0]?.apAdd3 || "")
                }
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่แก้ไขล่าสุด</label>
              <input
                // type="date"
                type="text"
                className="form-control input-spacing"
                name="updateDate"
                value={formMasterList[0]?.updateDate || ""}
                onChange={handleChangeMasterList}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>Due Date</label>
              <Datetime
                className="input-spacing-input-date"
                name="docDueDate"
                value={formMasterList[0]?.docDueDate || null}
                onChange={(date) =>
                  handleChangeDateMasterList(date, "docDueDate", 0)
                }
                dateFormat="DD-MM-YYYY"
                timeFormat={false}
                inputProps={{ readOnly: true, disabled: false }}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={
                  (formMasterList[0]?.apProvince || "") +
                  " " +
                  (formMasterList[0]?.apZipcode || "") +
                  "  " +
                  (formMasterList[0]?.apTaxNo || "")
                }
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้แก้ไขเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="updateByName"
                value={formMasterList[0]?.updateByName || ""}
                onChange={handleChangeMasterList}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            {/* <div className="d-flex align-items-center">
              <label>ประเภทเอกสาร</label>
              <select
                className="form-select form-control input-spacing"
                name="docType"
                value={formMasterList[0]?.docType}
                onChange={handleChangeMasterList}
                disabled={true}
              >
                {docRefType === "2" &&
                  tbDocType.map((docType) => (
                    <option key={docType.DocType_Id} value={docType.DocType_Id}>
                      {docType.DocType_Name}
                    </option>
                  ))}
              </select>
            </div> */}
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>ธนาคาร</label>
              {apBankList.length === 1 ? (
                <input
                  type="text"
                  className="form-control"
                  value={[
                    apBankList[0]?.bank_name,
                    apBankList[0]?.bank_acc_no,
                    apBankList[0]?.bank_acc_name,
                  ]
                    .filter(Boolean)
                    .join(" | ")}
                  readOnly
                  disabled
                />
              ) : (formMasterList[0]?.apName || formMasterList[0]?.arName) &&
                apBankList.length > 0 ? (
                <Select
                  name="bank_name"
                  className="react-select"
                  options={bankOptions}
                  value={
                    bankOptions.find(
                      (opt) =>
                        opt.bankName === formMasterList[0]?.bank_name &&
                        opt.bankAccNo === formMasterList[0]?.bank_acc_no &&
                        opt.bankAccName === formMasterList[0]?.bank_acc_name
                    ) || null
                  }
                  onChange={(selected) => {
                    setFormMasterList((prev) => [
                      {
                        ...prev[0],
                        bank_name: selected?.bankName || "",
                        bank_acc_no: selected?.bankAccNo || "",
                        bank_acc_name: selected?.bankAccName || "",
                      },
                    ]);
                  }}
                  placeholder="เลือกธนาคาร"
                  isClearable
                  isSearchable
                  isDisabled={mode === "U"}
                />
              ) : apBankList.length === 0 ? (
                <input
                  type="text"
                  className="form-control"
                  value="ผู้ขายยังไม่มีบัญชีธนาคารในระบบ"
                  readOnly
                  disabled
                  style={{ backgroundColor: "#f8d7da", color: "#721c24" }}
                />
              ) : (
                <input
                  type="text"
                  className="form-control"
                  value="กรุณาเลือกอ้างอิงเอกสาร หรือ ผู้ขายก่อน"
                  readOnly
                  disabled
                  style={{ backgroundColor: "#f8d7da", color: "#721c24" }}
                />
              )}
            </div>
          </div>

          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่อนุมัติ</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="approvedDate"
                value={formMasterList[0]?.approvedDate || ""}
                onChange={handleChangeMasterList}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            {/* <div className="d-flex align-items-center">
              <label>วัตถุประสงค์</label>
              <select
                name="docFor"
                value={formMasterList.docFor}
                onChange={handleChangeMasterList}
                disabled={true}
                className="form-select form-control input-spacing"
              >
                {docRefType === "2" && (
                  <>
                    <option value="1">ซื้อมาเพื่อใช้</option>
                    <option value="2">ซื้อมาเพื่อขาย</option>
                  </>
                )}
              </select>
            </div> */}
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center ">
              <label>Feedback</label>
              <div className="d-flex align-items-center gap-2 w-100">
                <input
                  type="text"
                  className="form-control input-spacing"
                  value={formMasterList[0]?.fb_Telephone || ""}
                  onChange={(e) =>
                    handleChangeMasterList(0, "fb_Telephone", e.target.value)
                  }
                  placeholder="เบอร์โทรศัพท์"
                />
                <input
                  type="text"
                  className="form-control input-spacing"
                  value={formMasterList[0]?.fb_Email || ""}
                  onChange={(e) =>
                    handleChangeMasterList(0, "fb_Email", e.target.value)
                  }
                  placeholder="อีเมล"
                />
              </div>
            </div>
          </div>

          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้อนุมัติเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="approvedByName"
                value={formMasterList[0]?.approvedByName || ""}
                onChange={handleChangeMasterList}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            {/* <div className="d-flex align-items-center">
              <label>วันที่เอกสารอ้างอิง</label>
              <input
                //type="date"
                type="text"
                className="form-control input-spacing"
                name="refDocDate"
                value={formMasterList[0]?.refDocDate || ""}
                onChange={handleChangeMasterList}
                disabled={true}
              />
            </div> */}
          </div>
          <div className="col-4">
            {/* <div className="d-flex align-items-center">
              <label>เลขบัญชีธนาคาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                // name="approvedByName"
                // value={formMasterList[0]?.approvedByName || ""}
                onChange={handleChangeMasterList}
                // disabled={true}
              />
            </div> */}
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>หมายเหตุอนุมัติ</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="approvedMemo"
                value={formMasterList[0]?.approvedMemo || ""}
                onChange={handleChangeMasterList}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <ul className="nav nav-tabs">
                  <li className="nav-item">
                    <button
                      style={{ cursor: "pointer", color: "#EF6C00" }}
                      className={`nav-link ${activeTab === "summary" ? "active" : ""
                        }`}
                      onClick={() => handleTabChange("summary")}
                    >
                      ยอดรวม
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      style={{ cursor: "pointer", color: "#EF6C00" }}
                      className={`nav-link ${activeTab === "details" ? "active" : ""
                        }`}
                      onClick={() => handleTabChange("details")}
                    >
                      รายละเอียดสินค้า
                    </button>
                  </li>
                </ul>
              </div>
              {activeTab === "summary" ? (
                <div className="card-body">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-5">
                            <div>
                              {/* <h4 className="card-title">ยอดท้ายบิล</h4> */}
                              <div>
                                <h4 className="card-title">ยอดท้ายบิล</h4>
                                <div className="row mt-3">
                                  <div className="col-12">
                                    <div className="row">
                                      <div className="col-3">
                                        <label>สถานะจ่าย</label>
                                      </div>
                                      <div className="col-6">
                                        <div className="radio-inline">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            name="paymentStatus"
                                            value="oneTime"
                                            checked={
                                              paymentStatus === "oneTime"
                                            }
                                            onChange={() =>
                                              handlePaymentStatusChange(
                                                "oneTime"
                                              )
                                            }
                                            disabled={mode === "U"}
                                          />
                                          <label className="form-check-label">
                                            จ่ายครั้งเดียว
                                          </label>
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            name="paymentStatus"
                                            value="installment"
                                            checked={
                                              paymentStatus === "installment"
                                            }
                                            onChange={() =>
                                              handlePaymentStatusChange(
                                                "installment"
                                              )
                                            }
                                            disabled={mode === "U"}
                                          />
                                          <label clPassName="form-check-label">
                                            จ่ายเป็นงวด
                                          </label>
                                        </div>
                                      </div>
                                      <div className="col-4">
                                        {paymentStatus === "installment" && (
                                          <input
                                            type="text"
                                            className="form-control text-end input-spacing"
                                            style={{ width: "100px" }}
                                            value={installmentCount}
                                            onChange={(e) =>
                                              handleInstallmentCountChange(
                                                e.target.value
                                              )
                                            }
                                          />
                                        )}
                                      </div>
                                    </div>
                                    <div className="row mt-4">
                                      <div className="col-3">
                                        <label>รวมราคา</label>
                                      </div>
                                      <div className="col-9">
                                        <input
                                          type="text"
                                          className="form-control text-end input-spacing"
                                          style={{ width: "100px" }}
                                          value={formatCurrency(
                                            totalPrice || 0
                                          )}
                                          disabled={true}
                                        />
                                      </div>
                                    </div>
                                    <div className="row mt-4">
                                      <div className="col-3">
                                        <label>รวมส่วนลด</label>
                                      </div>
                                      <div className="col-9">
                                        <input
                                          type="text"
                                          className="form-control text-end input-spacing"
                                          style={{ width: "100px" }}
                                          value={formatCurrency(
                                            receiptDiscount
                                          )}
                                          // onChange={(e) => {
                                          //   const value = e.target.value.replace(
                                          //     /[^0-9.]/g,
                                          //     ""
                                          //   );
                                          //   setReceiptDiscount(
                                          //     value ? parseFloat(value) : 0
                                          //   );
                                          // }}
                                          disabled={true}
                                        />
                                      </div>
                                    </div>
                                    <hr />
                                    <div className="row mt-2 align-items-center">
                                      <div className="col-3 d-flex align-items-center">
                                        {docRefType === "2" && (
                                          <input
                                            type="checkbox"
                                            className="me-2"
                                            checked={isVatChecked}
                                            onChange={handleVatChange}
                                            disabled={
                                              formMasterList[0]?.payStatus === 2
                                                ? true
                                                : false
                                            }
                                          />
                                        )}
                                        <label className="mb-0">VAT</label>
                                      </div>
                                      <div className="col-9">
                                        <input
                                          type="text"
                                          className="form-control text-end input-spacing"
                                          value={formatCurrency(vatAmount || 0)}
                                          disabled={true}
                                          style={{ width: "150px" }}
                                        />
                                      </div>
                                    </div>
                                    <hr />
                                    <div className="row mt-4">
                                      <div className="col-3">
                                        <label>
                                          <h5>หัก ณ ที่ จ่าย</h5>
                                        </label>
                                      </div>
                                      <div
                                        className="col-4"
                                        style={{ display: "flex" }}
                                      >
                                        <input
                                          type="text"
                                          className="form-control text-end input-spacing"
                                          style={{
                                            width: "150px",
                                            // color: "red",
                                            fontWeight: "bold",
                                            fontSize: "18px",
                                          }}
                                          value={inputValueTotalWT}
                                          onChange={CalculationTotalWT}
                                          onBlur={handleBlurTotalWT}
                                          onFocus={handleFocusTotalWT}
                                          disabled={
                                            formMasterList?.at(0)?.payStatus ===
                                              1
                                              ? false
                                              : true
                                          }
                                        />
                                        <div class="input-group-append">
                                          <button
                                            onClick={
                                              () => setdetailsTotalWT()
                                              // navigate("/tb-set-unit")
                                            }
                                            class="btn btn-lg text-white"
                                            style={{
                                              padding: "15px",
                                              borderRadius: "0 5px 5px 0",
                                              backgroundColor: "#EF6C00",
                                              marginLeft: "-1px",
                                            }}
                                            type="button"
                                          >
                                            +
                                          </button>
                                        </div>
                                        {taxData.at(0)?.amount !== 0.0 &&
                                          taxData.length !== 0 ? (
                                          <select
                                            className="form-control"
                                            value={selectedOption}
                                            disabled={true}
                                            style={{
                                              width: "150px",
                                              marginLeft: "10px",
                                            }}
                                          >
                                            <option value={1}>
                                              (1) ภ.ง.ด.1ก.
                                            </option>
                                            <option value={2}>
                                              (2) ภ.ง.ด.1ก.พิเศษ
                                            </option>
                                            <option value={3}>
                                              (3) ภ.ง.ด.2
                                            </option>
                                            <option value={4}>
                                              (4) ภ.ง.ด.3
                                            </option>
                                            <option value={5}>
                                              (5) ภ.ง.ด.2ก.
                                            </option>
                                            <option value={6}>
                                              (6) ภ.ง.ด.3ก.
                                            </option>
                                            <option value={7}>
                                              (7) ภ.ง.ด.53
                                            </option>
                                          </select>
                                        ) : null}
                                        {/* <button onClick={() => getMaxWtaxNo()}>
                                        test
                                      </button> */}
                                        <WtaxModal
                                          showWTModal={showWTModal}
                                          handleWTClose={handleWTClose}
                                          apDataList={apDataList}
                                          setTotalWT={setTotalWT}
                                          setInputValueTotalWT={
                                            setInputValueTotalWT
                                          }
                                          selectedOption={selectedOption}
                                          setSelectedOption={setSelectedOption}
                                          taxData={taxData}
                                          setTaxData={setTaxData}
                                          setTaxtotalAmount={setTaxtotalAmount}
                                          formMasterList={formMasterList}
                                          setFormMasterList={setFormMasterList}
                                          docRef={docRef}
                                          setDocRef={setDocRef}
                                          Ref_PAY_ID={Ref_PAY_ID}
                                          setRef_PAY_ID={setRef_PAY_ID}
                                        // onRowSelectAp={onRowSelectAp}
                                        />
                                      </div>
                                    </div>
                                    <div className="row mt-4">
                                      <div className="col-3">
                                        <label>
                                          <h5>รวมยอด</h5>
                                        </label>
                                      </div>
                                      <div className="col-4">
                                        <input
                                          type="text"
                                          className="form-control text-end input-spacing"
                                          style={{
                                            width: "100px",
                                            color: "red",
                                            fontWeight: "bold",
                                            fontSize: "18px",
                                          }}
                                          value={formatCurrency(
                                            grandTotal || 0
                                          )}
                                          disabled={true}
                                        />
                                      </div>
                                    </div>

                                    <div className="row mt-4">
                                      <div className="col-3">
                                        <label>
                                          <h5>ส่วนลดท้ายใบจ่าย</h5>
                                        </label>
                                      </div>
                                      <div className="col-4">
                                        <input
                                          type="text"
                                          className="form-control text-end input-spacing"
                                          style={{
                                            width: "100px",
                                            // color: "red",
                                            fontWeight: "bold",
                                            fontSize: "18px",
                                          }}
                                          // value={formatCurrency(disTotal || 0)}
                                          value={inputValuedisTotal}
                                          onChange={CalculationTotalDis}
                                          onBlur={handleBlurTotalDis}
                                          onFocus={handleFocusTotalDis}
                                          disabled={
                                            formMasterList?.at(0)?.payStatus ===
                                              1
                                              ? false
                                              : true
                                          }
                                        // disabled={true}
                                        />
                                      </div>
                                    </div>

                                    <div className="row mt-4">
                                      <div className="col-3">
                                        <label>
                                          <h5>รวมจ่ายสุทธิ</h5>
                                        </label>
                                      </div>
                                      <div className="col-4">
                                        <input
                                          type="text"
                                          className="form-control text-end input-spacing"
                                          style={{
                                            width: "100px",
                                            color: "red",
                                            fontWeight: "bold",
                                            fontSize: "18px",
                                          }}
                                          value={formatCurrency(
                                            FinalTotal || 0
                                          )}
                                          disabled={true}
                                        />
                                      </div>

                                      <div className="col-2">
                                        <label>
                                          <h5>ค้างชำระ</h5>
                                        </label>
                                      </div>
                                      <div className="col-3">
                                        <input
                                          type="text"
                                          className="form-control text-end input-spacing"
                                          style={{
                                            width: "80px",
                                            color: getOutstandingColor(),
                                            fontWeight: "bold",
                                            fontSize: "18px",
                                          }}
                                          value={formatOutstanding(
                                            outstandingBalance
                                          )}
                                          disabled={true}
                                        />
                                      </div>
                                    </div>

                                    <div className="row mt-3">
                                      <div className="col-3">
                                        <label>
                                          <h5>ช่องทางการจ่าย</h5>
                                        </label>
                                      </div>

                                      <div className="col-9 d-flex justify-content-start align-items-center flex-wrap gap-2">
                                        {Object.keys(PAYMENT_METHODS)
                                          .filter((method) => {
                                            return (
                                              window.location.pathname !==
                                              "/bill" ||
                                              [
                                                "cash",
                                                "transfer",
                                                "cheque",
                                              ].includes(method)
                                            );
                                          })
                                          .map((method) => {
                                            const isDisabled =
                                              GROUP_A.includes(method) &&
                                              isGroupASelected &&
                                              !paymentType[method];

                                            return (
                                              <button
                                                key={method}
                                                onClick={() =>
                                                  togglePaymentMethod(method)
                                                }
                                                disabled={isDisabled}
                                                className="btn"
                                                style={{
                                                  minWidth: "100px",
                                                  borderRadius: "8px",
                                                  border: "1px solid #ccc",
                                                  backgroundColor: paymentType[
                                                    method
                                                  ]
                                                    ? "#EF6C00"
                                                    : "white",
                                                  color: paymentType[method]
                                                    ? "white"
                                                    : "black",
                                                  fontWeight: paymentType[
                                                    method
                                                  ]
                                                    ? "bold"
                                                    : "normal",
                                                  cursor: isDisabled
                                                    ? "not-allowed"
                                                    : "pointer",
                                                  opacity: isDisabled ? 0.5 : 1,
                                                  transition: "0.2s",
                                                }}
                                              >
                                                {PAYMENT_METHODS[method]}
                                              </button>
                                            );
                                          })}

                                        {paymentType["cheque"] && (
                                          <div className="d-flex align-items-end gap-3 ms-2 mt-2 flex-wrap">
                                            {/* เช็คธนาคาร */}
                                            <div className="d-flex flex-column">
                                              <label
                                                style={{ fontSize: "14px" }}
                                              >
                                                เช็คธนาคาร
                                              </label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={chequeBank}
                                                onChange={(e) =>
                                                  setChequeBank(e.target.value)
                                                }
                                                placeholder="กรอกชื่อธนาคาร"
                                                style={{ minWidth: "180px" }}
                                              />
                                            </div>

                                            {/* เลขที่เช็ค */}
                                            <div className="d-flex flex-column">
                                              <label
                                                style={{ fontSize: "14px" }}
                                              >
                                                เลขที่เช็ค
                                              </label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={chequeNo}
                                                onChange={(e) =>
                                                  setChequeNo(e.target.value)
                                                }
                                                placeholder="กรอกเลขที่เช็ค"
                                                style={{ minWidth: "180px" }}
                                              />
                                            </div>

                                            {/* วันที่เช็ค */}
                                            <div className="d-flex flex-column">
                                              <label
                                                style={{ fontSize: "14px" }}
                                              >
                                                วันที่เช็ค
                                              </label>
                                              <input
                                                type="date"
                                                className="form-control"
                                                value={chequeDate}
                                                onChange={(e) =>
                                                  setChequeDate(e.target.value)
                                                }
                                                style={{ minWidth: "180px" }}
                                              />
                                            </div>
                                          </div>
                                        )}

                                        {paymentType["transfer"] && (
                                          <div className="d-flex align-items-end gap-3 ms-2 mt-2 flex-wrap">
                                            {/* เลขที่ธนาคาร ดึงมาจาก apBankList ดึงมาแสดง ห้ามกรอก */}
                                            <div className="d-flex flex-column">
                                              <label
                                                style={{ fontSize: "14px" }}
                                              >
                                                ธนาคาร
                                              </label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={
                                                  apBankList[0]?.bank_name || ""
                                                }
                                                placeholder=""
                                                style={{ minWidth: "180px" }}
                                                disabled={true}
                                              />
                                            </div>

                                            <div className="d-flex flex-column">
                                              <label
                                                style={{ fontSize: "14px" }}
                                              >
                                                เลขที่ธนาคาร
                                              </label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={

                                                  apBankList[0]?.bank_acc_no || ""
                                                }
                                                placeholder=""
                                                style={{ minWidth: "180px" }}
                                                disabled={true}
                                              />
                                            </div>

                                            {/* ชื่อบัญชั */}
                                            <div className="d-flex flex-column">
                                              <label
                                                style={{ fontSize: "14px" }}
                                              >
                                                ชื่อบัญชี
                                              </label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={

                                                  apBankList[0]?.bank_acc_name || ""
                                                }
                                                placeholder=""
                                                style={{ minWidth: "180px" }}
                                                disabled={true}
                                              />
                                            </div>

                                            {/* วันที่โอน */}
                                            <div className="d-flex flex-column">
                                              <label
                                                style={{ fontSize: "14px" }}
                                              >
                                                วันที่โอน
                                              </label>
                                              <input
                                                type="date"
                                                className="form-control"
                                                value={transferDate}
                                                onChange={(e) =>
                                                  setTransferDate(
                                                    e.target.value
                                                  )
                                                }
                                                style={{ minWidth: "180px" }}
                                              />
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-7">
                            <div>
                              <div className="row mt-3">
                                <div className="col-12">
                                  <div className="row">
                                    <div className="col-12">
                                      <div className="card">
                                        <div className="card-header d-flex justify-content-between align-items-center">
                                          <h4 className="card-title">
                                            ตารางจ่าย
                                          </h4>
                                        </div>
                                        <div className="card-body">
                                          <div
                                            className="table-responsive"
                                            style={{
                                              maxHeight: "300px",
                                              overflowY: "auto",
                                              zIndex: "1",
                                            }}
                                          >
                                            <table className="table table-striped table-hover">
                                              <thead className="thead-dark">
                                                <tr>
                                                  <th
                                                    className="text-center"
                                                    style={{ width: "2%" }}
                                                  >
                                                    #
                                                  </th>
                                                  <th
                                                    className="text-center"
                                                    style={{ width: "18%" }}
                                                  >
                                                    วันที่จ่าย
                                                  </th>
                                                  <th
                                                    className="text-center"
                                                    style={{ width: "18%" }}
                                                  >
                                                    จำนวนเงิน
                                                  </th>
                                                  <th
                                                    className="text-center"
                                                    style={{ width: "31%" }}
                                                  >
                                                    รายละเอียดเอกสาร
                                                  </th>
                                                  <th
                                                    className="text-center"
                                                    style={{ width: "31%" }}
                                                  >
                                                    หมายเหตุธุรการ
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {formMasterList.map(
                                                  (item, index) => (
                                                    <tr key={index + 1}>
                                                      <td className="text-center">
                                                        {index + 1}
                                                      </td>
                                                      <td className="text-center">
                                                        <input
                                                          type="text"
                                                          className="form-control text-center"
                                                          value={
                                                            item.datePay
                                                              ? item.datePay
                                                              : "เลือกวันที่"
                                                          }
                                                          onClick={() =>
                                                            openModalDatePicker(
                                                              index
                                                            )
                                                          }
                                                          disabled={
                                                            formMasterList[0]
                                                              ?.payStatus !== 1
                                                          }
                                                        />
                                                      </td>
                                                      <td className="text-end">
                                                        <input
                                                          type="text"
                                                          className="form-control text-end input-spacing"
                                                          value={
                                                            formMasterList[0]
                                                              ?.payStatus !== 1
                                                              ? formatCurrency(
                                                                parseCurrency(
                                                                  grandTotal
                                                                )
                                                              ) || 0
                                                              : formatCurrency(
                                                                parseCurrency(
                                                                  outstandingBalance
                                                                )
                                                              ) || 0
                                                          }
                                                          onChange={(e) =>
                                                            handleChangeMasterList(
                                                              index,
                                                              "amountPay",
                                                              e.target.value
                                                            )
                                                          }
                                                          onFocus={(e) =>
                                                            handleFocusMaster(
                                                              index,
                                                              "amountPay"
                                                            )
                                                          }
                                                          onBlur={(e) =>
                                                            handleBlurMaster(
                                                              index,
                                                              "amountPay",
                                                              e.target.value
                                                            )
                                                          }
                                                          disabled={
                                                            mode === "U" ||
                                                            paymentStatus ===
                                                            "oneTime"
                                                          }
                                                          onInput={(e) => {
                                                            if (
                                                              /^0+/.test(
                                                                e.target.value
                                                              )
                                                            ) {
                                                              e.target.value =
                                                                e.target.value.replace(
                                                                  /^0+/,
                                                                  ""
                                                                );
                                                            }
                                                          }}
                                                        />
                                                      </td>
                                                      <td className="text-center">
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          value={
                                                            item.docRemark1 ||
                                                            ""
                                                          }
                                                          onChange={(e) =>
                                                            handleChangeMasterList(
                                                              index,
                                                              "docRemark1",
                                                              e.target.value
                                                            )
                                                          }
                                                          disabled={
                                                            formMasterList[0]
                                                              ?.payStatus !== 1
                                                          }
                                                        />
                                                      </td>
                                                      <td className="text-center">
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          value={
                                                            item.docRemark2 ||
                                                            ""
                                                          }
                                                          onChange={(e) =>
                                                            handleChangeMasterList(
                                                              index,
                                                              "docRemark2",
                                                              e.target.value
                                                            )
                                                          }
                                                          disabled={
                                                            formMasterList[0]
                                                              ?.payStatus !== 1
                                                          }
                                                        />
                                                      </td>
                                                    </tr>
                                                  )
                                                )}
                                              </tbody>
                                            </table>

                                            {/* Modal For DatePicker */}
                                            <div
                                              className={`modal fade ${showModalDatePicker
                                                ? "show"
                                                : ""
                                                }`}
                                              style={{
                                                display: showModalDatePicker
                                                  ? "block"
                                                  : "none",
                                              }}
                                              tabIndex="-1"
                                              role="dialog"
                                            >
                                              <div
                                                className="modal-dialog modal-dialog-centered modal-sm"
                                                role="document"
                                              >
                                                <div className="modal-content">
                                                  <div
                                                    className="modal-header"
                                                    style={{
                                                      backgroundColor:
                                                        "#EF6C00",
                                                    }}
                                                  >
                                                    <h5 className="modal-title text-white">
                                                      เลือกวันที่
                                                    </h5>
                                                    <button
                                                      type="button"
                                                      className="close"
                                                      onClick={
                                                        closeModalDatePicker
                                                      }
                                                    >
                                                      <span>&times;</span>
                                                    </button>
                                                  </div>
                                                  <div
                                                    className="modal-body"
                                                    style={{
                                                      backgroundColor:
                                                        "#F5F7FD",
                                                    }}
                                                  >
                                                    <Datetime
                                                      className="input-spacing-input-date"
                                                      name="datePay"
                                                      value={
                                                        formMasterList[
                                                          selectedDateIndex
                                                        ]?.datePay || null
                                                      }
                                                      onChange={(date) => {
                                                        handleChangeDateMasterList(
                                                          date,
                                                          "datePay",
                                                          selectedDateIndex
                                                        );
                                                        closeModalDatePicker();
                                                      }}
                                                      dateFormat="DD-MM-YYYY"
                                                      timeFormat={false}
                                                      inputProps={{
                                                        readOnly: true,
                                                        disabled: false,
                                                      }}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-2" style={{ margin: "10px 0px" }}>
                        <button
                          className="btn text-white mx-3"
                          style={{
                            backgroundColor: " rgb(239, 108, 0)",
                            whiteSpace: "nowrap",
                            padding: "15px",
                            fontSize: "15px",
                          }}
                          onClick={() => handleShowModal()}
                        >
                          แนบไฟล์
                        </button>
                        <button
                          className="btn text-white mx-3"
                          style={{
                            backgroundColor: " rgb(239, 108, 0)",
                            whiteSpace: "nowrap",
                            padding: "15px",
                            fontSize: "15px",
                          }}
                          onClick={() => setShowViewModal(true)}
                          disabled={mode === "I" ? true : false}
                        >
                          ดูไฟล์ ({selectedFiles?.length})
                        </button>
                        {showViewModal && (
                          <FileModal
                            showModal={showViewModal}
                            handleClose={handleClose}
                            Files={selectedFiles}
                            mode={"U"}
                            handleRemoveImage={handleRemoveImage}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="card-body">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title">รายละเอียดสินค้า</h4>
                        <button
                          type="button"
                          className="btn text-white mx-3"
                          onClick={handleItemShow}
                          style={{
                            backgroundColor: "rgb(239, 108, 0)",
                            whiteSpace: "nowrap",
                            padding: "10px",
                            fontSize: "15px",
                          }}
                          hidden={
                            docRefType === "1" || docRefType === "3"
                              ? true
                              : false
                          }
                        >
                          <i className="fa fa-plus"></i> เพิ่มรายการ
                        </button>
                      </div>
                      <ItemModal
                        formDetailList={formDetailList}
                        showItemModal={showItemModal}
                        handleItemClose={handleItemClose}
                        itemDataList={itemDataList}
                        onRowSelectItem={onRowSelectItem}
                        onRowSelectItem02={onRowSelectItem02}
                      />
                      <div className="card-body">
                        <div
                          className="table-responsive"
                          style={{ maxHeight: "500px", overflowY: "auto" }}
                        >
                          <table
                            id="basic-datatables"
                            className="table table-striped table-hover"
                          >
                            <thead className="thead-dark">
                              <tr>
                                <th
                                  className="text-center"
                                  style={{ width: "2%" }}
                                >
                                  #
                                </th>
                                {docRefType === "1" && (
                                  <th
                                    className="text-center"
                                    style={{ width: "8%" }}
                                  >
                                    เลขที่เอกสาร (REC)
                                  </th>
                                )}
                                <th
                                  className="text-center"
                                  style={{
                                    width: docRefType !== "1" ? "12%" : "10%",
                                  }}
                                >
                                  รหัสสินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{
                                    width: docRefType === "1" ? "16%" : "36%",
                                  }}
                                >
                                  ชื่อสินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "8%" }}
                                >
                                  จำนวน
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "6%" }}
                                >
                                  หน่วย
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "8%" }}
                                >
                                  ราคาต่อหน่วย
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "8%" }}
                                >
                                  ส่วนลด
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "5%" }}
                                >
                                  %
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "10%" }}
                                >
                                  จำนวนเงินรวม
                                </th>
                                {docRefType === "2" && (
                                  <th
                                    className="text-center"
                                    style={{ width: "3%" }}
                                  >
                                    ลบ
                                  </th>
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {formDetailList
                                .sort((a, b) => a.line - b.line)
                                .map((item, index) => (
                                  <tr key={item.itemId || index + 1}>
                                    {/* # */}
                                    <td className="text-center">{index + 1}</td>

                                    {/* # RecNo */}
                                    <td
                                      hidden={docRefType === "1" ? false : true}
                                      className="text-center"
                                    >
                                      <span>{item.recNo || ""}</span>
                                    </td>

                                    {/* รหัสสินค้า */}
                                    <td className="text-center">
                                      <span>{item.itemCode || ""}</span>
                                    </td>

                                    {/* ชื่อสินค้า */}
                                    <td className="text-left">
                                      {window.location.pathname ===
                                        "/payment-voucher" ||
                                        window.location.pathname ===
                                        "/invoice" ? (
                                        <span
                                          style={{
                                            cursor: "pointer",
                                            backgroundColor: "#f8f9fa",
                                            border: "1px solid #ced4da",
                                            borderRadius: "4px",
                                            fontSize: "16px",
                                            textDecoration: "none",
                                            color: "#212529",
                                            display: "inline-block",
                                            width: "100%",
                                            background: "white",
                                            padding: "10px 15px",
                                          }}
                                          onClick={() =>
                                            handleOpenModal(index, item)
                                          }
                                        >
                                          {item.itemName || "คลิกเพื่อแก้ไข"}
                                        </span>
                                      ) : (
                                        <span>
                                          {window.location.pathname ===
                                            "/purchase-request"
                                            ? item.isGift
                                              ? `FREE ${item.itemNameEN}`
                                              : item.itemNameEN
                                            : item.itemName || ""}
                                        </span>
                                      )}
                                    </td>

                                    {/* จำนวน */}
                                    <td className="text-center">
                                      {docRefType === "1" ? (
                                        <span>{item.itemQty || 0}</span>
                                      ) : (
                                        <input
                                          type="text"
                                          className="form-control text-center"
                                          value={item.itemQty || 0}
                                          onChange={(e) =>
                                            handleChangeDetail(
                                              index,
                                              "itemQty",
                                              e.target.value
                                            )
                                          }
                                          onFocus={(e) =>
                                            handleFocusDetail(index, "itemQty")
                                          }
                                          onBlur={(e) =>
                                            handleBlurDetail(
                                              index,
                                              "itemQty",
                                              e.target.value
                                            )
                                          }
                                          disabled={docRefType === "1"}
                                          onInput={(e) => {
                                            if (/^0+/.test(e.target.value)) {
                                              e.target.value =
                                                e.target.value.replace(
                                                  /^0+/,
                                                  ""
                                                );
                                            }
                                          }}
                                        />
                                      )}
                                    </td>

                                    {/* หน่วย */}
                                    <td className="text-center">
                                      <input
                                        type="text"
                                        className="form-control text-end"
                                        value={item.itemUnit || ""}
                                        onChange={(e) =>
                                          handleChangeDetail(
                                            index,
                                            "itemUnit",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </td>

                                    {/* ราคาต่อหน่วย */}
                                    <td className="text-end">
                                      {/* {docRefType === "1" ||
                                      docRefType === "3" ? (
                                        <span>{item.itemPriceUnit || 0}</span>
                                      ) : ( */}
                                      <input
                                        type="text"
                                        className="form-control text-end"
                                        value={item.itemPriceUnit || ""}
                                        onChange={(e) =>
                                          handleChangeDetail(
                                            index,
                                            "itemPriceUnit",
                                            e.target.value
                                          )
                                        }
                                        onFocus={() =>
                                          handleFocusDetail(
                                            index,
                                            "itemPriceUnit"
                                          )
                                        }
                                        onBlur={(e) =>
                                          handleBlurDetail(
                                            index,
                                            "itemPriceUnit",
                                            e.target.value
                                          )
                                        }
                                        disabled={
                                          docRefType === "1" ||
                                          docRefType === "3"
                                        }
                                        onInput={(e) => {
                                          if (/^0+/.test(e.target.value)) {
                                            e.target.value =
                                              e.target.value.replace(/^0+/, "");
                                          }
                                        }}
                                      />
                                      {/* // )} */}
                                    </td>

                                    {/* ส่วนลด */}
                                    <td className="text-end">
                                      {docRefType === "1" ||
                                        docRefType === "3" ? (
                                        <span>{item.itemDiscount || 0}</span>
                                      ) : (
                                        <input
                                          type="text"
                                          className="form-control text-end"
                                          value={item.itemDiscount || 0}
                                          onChange={(e) =>
                                            handleChangeDetail(
                                              index,
                                              "itemDiscount",
                                              e.target.value
                                            )
                                          }
                                          onFocus={() =>
                                            handleFocusDetail(
                                              index,
                                              "itemDiscount"
                                            )
                                          }
                                          onBlur={(e) =>
                                            handleBlurDetail(
                                              index,
                                              "itemDiscount",
                                              e.target.value
                                            )
                                          }
                                          disabled={
                                            docRefType === "1" ||
                                            docRefType === "3"
                                          }
                                          onInput={(e) => {
                                            if (/^0+/.test(e.target.value)) {
                                              e.target.value =
                                                e.target.value.replace(
                                                  /^0+/,
                                                  ""
                                                );
                                            }
                                          }}
                                        />
                                      )}
                                    </td>

                                    {/* % */}
                                    <td className="text-center">
                                      {docRefType === "1" ||
                                        docRefType === "3" ? (
                                        <span>
                                          {item.itemDisType === "1"
                                            ? "฿"
                                            : item.itemDisType === "2"
                                              ? "%"
                                              : ""}
                                        </span>
                                      ) : (
                                        <select
                                          className="form-select"
                                          value={item.itemDisType || ""}
                                          onChange={(e) =>
                                            handleChangeDetail(
                                              index,
                                              "itemDisType",
                                              e.target.value
                                            )
                                          }
                                          disabled={
                                            docRefType === "1" ||
                                            docRefType === "3"
                                          }
                                        >
                                          <option value="1">฿</option>
                                          <option value="2">%</option>
                                        </select>
                                      )}
                                    </td>

                                    {/* จำนวนเงินรวม */}
                                    <td className="text-end">
                                      <span>
                                        {formatCurrency(item.itemTotal || 0)}
                                      </span>
                                    </td>

                                    {docRefType === "2" && (
                                      <td className="text-center">
                                        <button
                                          type="button"
                                          className="btn btn-danger"
                                          onClick={() => handleRemoveRow(index)}
                                          disabled={
                                            docRefType === "1" ||
                                            docRefType === "3"
                                          }
                                        >
                                          ลบ
                                        </button>
                                      </td>
                                    )}
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <br />
      {showEditModal && (
        <div className="modal fade show" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">แก้ไขชื่อสินค้า</h5>
                <button
                  className="btn-close"
                  onClick={handleCloseModal}
                ></button>
              </div>
              <div className="modal-body">
                <textarea
                  className="form-control"
                  value={newItemName}
                  onChange={(e) => setNewItemName(e.target.value)}
                  // maxLength={200}
                  rows={5} // ให้เริ่มต้นเล็กสุด แต่ขยายเมื่อพิมพ์เพิ่ม
                  style={{
                    minHeight: "50px",
                    maxHeight: "300px",
                    resize: "none", // ไม่ให้ผู้ใช้ปรับเอง แต่ขยายอัตโนมัติ
                    overflowY: "hidden",
                    lineHeight: "1.8", // ปรับระยะห่างระหว่างบรรทัด
                    padding: "10px", // เพิ่มพื้นที่ให้พิมพ์ง่ายขึ้น
                    fontSize: "16px", // ให้ตัวหนังสืออ่านง่าย
                  }}
                  onInput={(e) => {
                    e.target.style.height = "auto"; // รีเซ็ตขนาดก่อนคำนวณใหม่
                    e.target.style.height = e.target.scrollHeight + "px"; // ปรับขนาดตามข้อความ
                  }}
                />
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={handleCloseModal}
                >
                  ยกเลิก
                </button>
                <button className="btn btn-primary" onClick={handleSaveChanges}>
                  บันทึก
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <FormAction
        onSubmit={handleSubmit}
        onUpdate={handleUpdate}
        onCancel={handleCancel}
        mode={mode}
        disabled={formMasterList[0]?.payStatus !== 1}
        footer={true}
      />
    </>
  );
}

export default Form;
